export interface LocatieData {
  city: string;
  slug: string;
  province: string;
  region: string;
  priority: number;
  driveTime: string;
  driveMinutes: number;
  nearbyTowns: string[];
  highway: string;
  seoTitle: string;
  seoDescription: string;
  h1: string;
  intro: string;
  problemParagraph: string;
  whyLokeren: string;
  trustParagraph: string;
  cta: string;
  faqs: { q: string; a: string }[];
  nearbyCityLinks: string[];
}

export const locatiesData: LocatieData[] = [
  // ─── OOST-VLAANDEREN — PRIORITY ────────────────────────────────────────────
  {
    city: 'Lokeren',
    slug: 'lokeren',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 1,
    driveTime: '5 minuten',
    driveMinutes: 5,
    nearbyTowns: ['Eksaarde', 'Daknam', 'Zele', 'Waasmunster', 'Moerbeke'],
    highway: 'E17 / N70',
    seoTitle: 'Roetfilter Reinigen in Lokeren | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen in Lokeren bij Roetfilter Center, Dijkstraat 22. Professionele DPF reiniging, diagnose en revisie. Gratis diagnose bij herstelling. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Lokeren',
    intro: 'Roetfilter Center is gevestigd in het hart van Lokeren, aan Dijkstraat 22. Als inwoner van Lokeren bent u letterlijk om de hoek bij de enige erkende roetfilterspecialist in de regio. Geen lange rit, geen onzekerheid — gewoon een afspraak maken en dezelfde dag geholpen worden.',
    problemParagraph: 'Lokerse automobilisten rijden vaak korte trajecten door de stad of pendelen via de N70 richting Sint-Niklaas of Gent. Die korte ritten zijn precies de reden waarom roetfilters sneller verstoppen: de motor bereikt niet de temperatuur die nodig is voor automatische regeneratie. Het resultaat? Een brandend roetfilterlampje, vermogensverlies of zelfs noodloop. Wacht niet tot de situatie verergert.',
    whyLokeren: 'Als Lokeraar hoeft u nergens ver voor te rijden. Onze werkplaats aan Dijkstraat 22 is uw dichtstbijzijnde DPF-specialist. We werken met professionele reinigingsapparatuur, voeren een volledige diagnose uit vóór en na de reiniging, en geven u een gedetailleerd rapport mee. Geen verrassingen, geen onnodige vervangingen.',
    trustParagraph: 'Meer dan 12 jaar ervaring, honderden tevreden klanten uit Lokeren en omgeving, en een garantie van 1 jaar op elke reiniging. Dat is de Roetfilter Center-belofte. Wij zijn uw buur én uw specialist.',
    cta: 'Woon je in Lokeren? Bel ons nu op 0498 54 54 74 of stap gewoon binnen aan Dijkstraat 22.',
    faqs: [
      { q: 'Kan ik zonder afspraak langskomen in Lokeren?', a: 'Voor een diagnose kunt u in veel gevallen dezelfde dag terecht. Voor een volledige reiniging raden we een afspraak aan zodat we de nodige tijd kunnen reserveren. Bel ons op 0498 54 54 74.' },
      { q: 'Hoe lang duurt een roetfilter reiniging in Lokeren?', a: 'Een volledige reiniging inclusief demontage, reinigen, drogen en montage duurt gemiddeld 4 tot 6 uur. U kunt uw wagen dezelfde dag ophalen.' },
      { q: 'Wat kost roetfilter reinigen in Lokeren?', a: 'Reiniging voor personenwagens kost €195–€250. Jeep/SUV €220–€270. Bestelwagens €250–€350. De diagnose (€75) wordt terugbetaald bij een herstelling.' },
      { q: 'Mijn roetfilterlampje brandt — moet ik meteen komen?', a: 'Ja, wacht niet te lang. Een brandend lampje betekent dat de filter verzadigd is. Blijft u rijden, dan kan de filter beschadigd raken en is vervanging nodig in plaats van reiniging.' },
      { q: 'Werken jullie ook voor bestelwagens en bedrijfsvoertuigen?', a: 'Absoluut. We reinigen roetfilters van personenwagens, bestelwagens, SUVs en zelfs trucks en bussen. Bel voor een offerte op maat.' },
    ],
    nearbyCityLinks: ['gent', 'sint-niklaas', 'dendermonde', 'zele', 'waasmunster', 'hamme', 'temse', 'aalst'],
  },
  {
    city: 'Gent',
    slug: 'gent',
    province: 'Oost-Vlaanderen',
    region: 'Gent',
    priority: 1,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Gentbrugge', 'Mariakerke', 'Wondelgem', 'Ledeberg', 'Destelbergen', 'Merelbeke'],
    highway: 'E17 / R4',
    seoTitle: 'Roetfilter Reinigen in Gent | Roetfilter Center',
    seoDescription: 'Roetfilter laten reinigen in Gent of omgeving? Roetfilter Center helpt met DPF diagnose, roetfilter reiniging, AdBlue storingen en uitstootproblemen. Slechts 20 minuten van Gent naar Lokeren. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Gent',
    intro: 'Rijdt u in Gent met een dieselwagen en brandt het roetfilterlampje? Roetfilter Center in Lokeren is uw dichtstbijzijnde erkende DPF-specialist — slechts 20 minuten rijden via de E17. Gentse automobilisten kiezen massaal voor onze werkplaats omdat we snelle diagnose, transparante communicatie en bewezen resultaten combineren.',
    problemParagraph: 'Gent is een stad van files, lage-emissiezone en korte stadsritten. Wie dagelijks door de Gentse binnenstad rijdt of pendelt via de R4, geeft zijn dieselmotor nauwelijks de kans om de roetfilter automatisch te regenereren. Dat leidt tot een verstopte DPF, een brandend waarschuwingslampje, merkbaar vermogensverlies of zelfs een motor die in noodloop gaat. Bovendien riskeert u bij de autokeuring te zakken door te hoge roetuitstoot.',
    whyLokeren: 'Vanuit Gent rijdt u via de E17 richting Antwerpen en neemt u de afrit Lokeren. In 20 minuten staat u bij ons aan de deur. Wij voeren een volledige diagnose uit met professionele meetapparatuur, reinigen de roetfilter met gespecialiseerde waterdrukinstallatie en testen het resultaat met een officiële deeltjestest — dezelfde methode die bij de autokeuring wordt gebruikt.',
    trustParagraph: 'Honderden Gentse klanten gingen u voor. Van compacte stadswagens tot grote SUVs en bestelwagens — wij kennen de DPF-problematiek van Gentse rijders door en door. Onze technici werken met alle merken en modellen, van Volkswagen en Peugeot tot BMW en Mercedes.',
    cta: 'Klant uit Gent? Bel ons op 0498 54 54 74 of vraag een gratis offerte aan. Wij helpen u dezelfde dag.',
    faqs: [
      { q: 'Hoe ver is Gent van Roetfilter Center in Lokeren?', a: 'Vanuit het centrum van Gent rijdt u via de E17 richting Antwerpen en neemt u de afrit Lokeren. De rit duurt gemiddeld 20 minuten buiten de spits.' },
      { q: 'Mag ik met een brandend roetfilterlampje nog rijden vanuit Gent naar Lokeren?', a: 'In de meeste gevallen kunt u nog rijden als het lampje net is gaan branden. Rijdt u echter al een tijdje met het lampje of heeft u ook vermogensverlies, bel ons dan eerst zodat we kunnen inschatten of de rit veilig is.' },
      { q: 'Valt roetfilter reiniging onder de lage-emissiezone regels in Gent?', a: 'Een gereinigde roetfilter zorgt voor lagere uitstoot en helpt u voldoen aan de emissienormen voor de Gentse LEZ. Na reiniging voeren wij een officiële emissietest uit.' },
      { q: 'Wat zijn de meest voorkomende DPF-problemen bij Gentse stadsrijders?', a: 'Korte ritten door de stad zijn de hoofdoorzaak. De motor bereikt niet de 550–600°C die nodig is voor automatische regeneratie. Wij zien dit dagelijks bij klanten uit Gent, Gentbrugge en Mariakerke.' },
      { q: 'Bieden jullie een ophaalservice aan voor klanten uit Gent?', a: 'Ja, in overleg is een ophaalservice mogelijk. Bel ons op 0498 54 54 74 voor de mogelijkheden en tarieven.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'dendermonde', 'aalst', 'destelbergen', 'merelbeke', 'evergem', 'zele'],
  },
  {
    city: 'Sint-Niklaas',
    slug: 'sint-niklaas',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 1,
    driveTime: '15 minuten',
    driveMinutes: 15,
    nearbyTowns: ['Belsele', 'Nieuwkerken-Waas', 'Sinaai', 'Stekene', 'Beveren-Kruibeke-Zwijndrecht'],
    highway: 'N70 / E17',
    seoTitle: 'Roetfilter Reinigen in Sint-Niklaas | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Sint-Niklaas en het Waasland. Slechts 15 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Sint-Niklaas',
    intro: 'Sint-Niklaas is de grootste stad van het Waasland en ligt op slechts 15 minuten van onze werkplaats in Lokeren. Als hoofdstad van de regio zien we dagelijks klanten uit Sint-Niklaas, Belsele, Nieuwkerken-Waas en omgeving. Roetfilter Center is dé DPF-specialist voor het volledige Waasland.',
    problemParagraph: 'Automobilisten uit Sint-Niklaas rijden vaak via de N70 of E17 voor dagelijkse verplaatsingen. Wie pendelt naar Gent of Antwerpen, rijdt weliswaar langere trajecten, maar wie dagelijks in de stad rijdt of korte ritten maakt naar Belsele of Nieuwkerken-Waas, ziet zijn roetfilter sneller verstoppen. Een verstopte DPF uit zich in vermogensverlies, hogere brandstofkosten en een brandend lampje op het dashboard.',
    whyLokeren: 'Vanuit Sint-Niklaas rijdt u via de N70 rechtstreeks naar Lokeren — 15 minuten en u staat bij ons. Geen omrijden, geen gedoe. Wij voeren een grondige diagnose uit, reinigen de roetfilter professioneel en geven u een volledig rapport mee. Transparant, eerlijk en zonder verrassingen.',
    trustParagraph: 'Roetfilter Center is al meer dan 12 jaar de vertrouwde DPF-specialist voor het Waasland. Klanten uit Sint-Niklaas waarderen onze snelle service, duidelijke communicatie en eerlijke prijzen. We werken met alle merken — van Opel en Ford tot Audi en BMW.',
    cta: 'Klant uit Sint-Niklaas of het Waasland? Bel 0498 54 54 74 of vraag online een offerte aan.',
    faqs: [
      { q: 'Hoe ver is Sint-Niklaas van Roetfilter Center?', a: 'Vanuit het centrum van Sint-Niklaas rijdt u via de N70 richting Lokeren. De rit duurt gemiddeld 15 minuten.' },
      { q: 'Mijn DPF-lampje brandt in Sint-Niklaas — wat nu?', a: 'Bel ons op 0498 54 54 74. We bespreken de symptomen en plannen een afspraak in. In de meeste gevallen kunt u dezelfde dag terecht voor diagnose.' },
      { q: 'Werken jullie ook voor garagebedrijven in het Waasland?', a: 'Ja, we werken samen met verschillende garagebedrijven in Sint-Niklaas en omgeving. Neem contact op voor onze B2B-tarieven.' },
      { q: 'Wat is het verschil tussen roetfilter reinigen en vervangen?', a: 'Reiniging is in de meeste gevallen voldoende en kost een fractie van vervanging. Wij voeren altijd eerst een diagnose uit om te bepalen of reiniging mogelijk is. Vervanging adviseren we alleen als de filter echt beschadigd is.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar. Een reiniging duurt gemiddeld 4 tot 6 uur.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'dendermonde', 'stekene', 'beveren-kruibeke-zwijndrecht', 'temse', 'hamme', 'waasmunster'],
  },
  {
    city: 'Dendermonde',
    slug: 'dendermonde',
    province: 'Oost-Vlaanderen',
    region: 'Dendervallei',
    priority: 1,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Lebbeke', 'Buggenhout', 'Zele', 'Hamme', 'Berlare'],
    highway: 'N47 / N16',
    seoTitle: 'Roetfilter Reinigen in Dendermonde | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Dendermonde en de Dendervallei. 25 minuten naar Lokeren. Professionele DPF diagnose, reiniging en revisie. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Dendermonde',
    intro: 'Dendermonde, de stad aan de samenvloeiing van Dender en Schelde, ligt op 25 minuten van onze werkplaats in Lokeren. Klanten uit Dendermonde, Lebbeke, Buggenhout en de ruime Dendervallei vinden bij Roetfilter Center een betrouwbare partner voor alle DPF-gerelateerde problemen.',
    problemParagraph: 'Dendermondse automobilisten pendelen vaak via de N47 richting Gent of via de N16 richting Mechelen en Antwerpen. Die pendeltrajekten zijn lang genoeg voor regeneratie, maar wie ook korte ritten in de stad maakt, ziet zijn roetfilter geleidelijk verstoppen. Bovendien zien we bij klanten uit Dendermonde regelmatig EGR-klep problemen in combinatie met een verstopte DPF — een combinatie die we in één bezoek kunnen aanpakken.',
    whyLokeren: 'Vanuit Dendermonde rijdt u via de N47 richting Lokeren — een vlotte rit van 25 minuten. Bij Roetfilter Center krijgt u een volledige diagnose, professionele reiniging en een gedetailleerd rapport. We werken met alle merken en modellen, en onze technici zijn gespecialiseerd in de meest complexe DPF-problemen.',
    trustParagraph: 'Klanten uit Dendermonde en de Dendervallei kiezen voor Roetfilter Center omdat we eerlijk adviseren. We vervangen nooit een roetfilter als reiniging volstaat. Onze transparante werkwijze en 1 jaar garantie geven u de zekerheid die u verdient.',
    cta: 'Klant uit Dendermonde? Bel 0498 54 54 74 of vraag een gratis offerte aan via onze website.',
    faqs: [
      { q: 'Hoe kom ik vanuit Dendermonde naar Roetfilter Center?', a: 'Neem de N47 richting Lokeren. De rit duurt gemiddeld 25 minuten. Ons adres is Dijkstraat 22, 9160 Lokeren.' },
      { q: 'Mijn wagen uit Dendermonde gaat in noodloop — wat moet ik doen?', a: 'Noodloop is een ernstig signaal. Bel ons onmiddellijk op 0498 54 54 74. We bespreken de situatie en plannen een urgente afspraak in.' },
      { q: 'Kunnen jullie ook EGR-klep problemen oplossen?', a: 'Ja, we behandelen EGR-klep problemen, AdBlue-storingen en katalysatorproblemen naast roetfilter reiniging. Alles onder één dak.' },
      { q: 'Wat als mijn roetfilter niet meer te reinigen is?', a: 'Als de filter beschadigd is, adviseren we vervanging. We werken met kwaliteitsonderdelen en geven ook op vervanging garantie.' },
      { q: 'Bieden jullie een gratis diagnose aan?', a: 'De diagnose kost €75, maar dit bedrag wordt volledig terugbetaald als u bij ons een herstelling laat uitvoeren.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'sint-niklaas', 'hamme', 'zele', 'lebbeke', 'aalst', 'temse'],
  },
  {
    city: 'Aalst',
    slug: 'aalst',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 1,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Ninove', 'Erpe-Mere', 'Lebbeke', 'Denderleeuw', 'Haaltert'],
    highway: 'E40 / N9',
    seoTitle: 'Roetfilter Reinigen in Aalst | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Aalst en de Denderstreek. 35 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Gratis diagnose bij herstelling. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Aalst',
    intro: 'Aalst is een van de grootste steden van Oost-Vlaanderen en een belangrijke pendelstad langs de E40. Klanten uit Aalst, Ninove, Erpe-Mere en de ruime Denderstreek rijden dagelijks naar onze werkplaats in Lokeren — slechts 35 minuten via de E40 of N9. Roetfilter Center is de erkende DPF-specialist voor de volledige Denderstreek.',
    problemParagraph: 'Aalsterse automobilisten pendelen massaal naar Brussel of Gent via de E40. Lange snelwegritten zijn goed voor de roetfilter, maar wie ook dagelijks in de stad rijdt of korte ritten maakt, ziet zijn DPF geleidelijk verstoppen. We zien bij klanten uit Aalst ook regelmatig problemen na een mislukte regeneratiepoging — de motor heeft geprobeerd de filter te reinigen maar is er niet in geslaagd, met olieverontreiniging als gevolg.',
    whyLokeren: 'Vanuit Aalst rijdt u via de E40 of N9 richting Lokeren. In 35 minuten staat u bij ons. We voeren een volledige diagnose uit, controleren ook de oliekwaliteit en het EGR-systeem, en reinigen de roetfilter professioneel. U krijgt een volledig rapport mee en weet exact wat er gedaan is.',
    trustParagraph: 'Klanten uit Aalst en de Denderstreek waarderen onze directe aanpak. Geen omwegen, geen onnodige kosten. We leggen alles uit in begrijpelijke taal en adviseren alleen wat echt nodig is. Met 12 jaar ervaring en 1 jaar garantie bent u bij ons in goede handen.',
    cta: 'Klant uit Aalst of de Denderstreek? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Aalst van Roetfilter Center in Lokeren?', a: 'Vanuit Aalst rijdt u via de E40 of N9 richting Lokeren. De rit duurt gemiddeld 35 minuten buiten de spits.' },
      { q: 'Mijn roetfilter is verstopt na een mislukte regeneratie — wat nu?', a: 'Dit is een veelvoorkomend probleem. Bel ons op 0498 54 54 74. We voeren een diagnose uit en bepalen of reiniging volstaat of dat aanvullende behandeling nodig is.' },
      { q: 'Kan ik mijn wagen achterlaten en later ophalen?', a: 'Ja, u kunt uw wagen achterlaten. We bellen u zodra de wagen klaar is. De meeste reinigingen zijn dezelfde dag klaar.' },
      { q: 'Werken jullie ook voor bedrijven uit Aalst?', a: 'Absoluut. We werken voor particulieren en bedrijven. Voor vloten bieden we speciale tarieven aan. Neem contact op voor meer informatie.' },
      { q: 'Wat als mijn wagen ook EGR-problemen heeft?', a: 'We behandelen EGR-klep problemen in combinatie met roetfilter reiniging. Zo lost u beide problemen in één bezoek op.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'dendermonde', 'ninove', 'erpe-mere', 'haaltert', 'lebbeke', 'sint-niklaas'],
  },
  {
    city: 'Temse',
    slug: 'temse',
    province: 'Oost-Vlaanderen',
    region: 'Scheldeland',
    priority: 1,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Bornem', 'Puurs-Sint-Amands', 'Hamme', 'Kruibeke', 'Bazel'],
    highway: 'N16 / N70',
    seoTitle: 'Roetfilter Reinigen in Temse | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Temse en het Scheldeland. 20 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Temse',
    intro: 'Temse, gelegen aan de Schelde tussen Sint-Niklaas en Antwerpen, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Temse, Bornem, Puurs-Sint-Amands en het ruime Scheldeland kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Temse is een typische pendelgemeente. Veel inwoners rijden dagelijks naar Antwerpen of Gent via de N16 of E17. Die pendeltrajekten zijn lang genoeg voor regeneratie, maar de combinatie met korte ritten in de gemeente zorgt toch voor problemen. We zien bij klanten uit Temse ook regelmatig AdBlue-storingen bij nieuwere dieselwagens met SCR-systeem.',
    whyLokeren: 'Vanuit Temse rijdt u via de N16 of N70 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons. Wij voeren een grondige diagnose uit, behandelen zowel DPF- als AdBlue-problemen en geven u een volledig rapport mee. Transparant en eerlijk.',
    trustParagraph: 'Klanten uit Temse en het Scheldeland weten ons te vinden. Onze reputatie is gebouwd op eerlijk advies, professioneel werk en een garantie van 1 jaar. We werken met alle merken en modellen.',
    cta: 'Klant uit Temse of het Scheldeland? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Temse van Roetfilter Center?', a: 'Vanuit Temse rijdt u via de N16 of N70 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn AdBlue-lampje brandt in Temse — wat moet ik doen?', a: 'Een AdBlue-storing kan verschillende oorzaken hebben. Bel ons op 0498 54 54 74 voor een diagnose. We lossen AdBlue-storingen op naast roetfilter problemen.' },
      { q: 'Kan ik mijn bestelwagen ook laten reinigen?', a: 'Ja, we reinigen roetfilters van bestelwagens voor €250–€350. Bestelwagens zijn welkom.' },
      { q: 'Wat als mijn wagen afgekeurd is voor roet?', a: 'We helpen u snel. Na reiniging voeren we een officiële emissietest uit. U krijgt een rapport mee voor de herkeuring.' },
      { q: 'Bieden jullie een garantie op de reiniging?', a: 'Ja, wij geven 1 jaar garantie op elke roetfilter reiniging.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'dendermonde', 'hamme', 'bornem', 'kruibeke', 'beveren-kruibeke-zwijndrecht', 'antwerpen'],
  },
  {
    city: 'Hamme',
    slug: 'hamme',
    province: 'Oost-Vlaanderen',
    region: 'Scheldeland',
    priority: 1,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Waasmunster', 'Moerzeke', 'Zele', 'Dendermonde', 'Buggenhout'],
    highway: 'N47',
    seoTitle: 'Roetfilter Reinigen in Hamme | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Hamme. 20 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Gratis diagnose bij herstelling. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Hamme',
    intro: 'Hamme, de gemeente aan de Durme en de Schelde, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Hamme, Moerzeke en omgeving kiezen voor Roetfilter Center omdat we snel, eerlijk en professioneel werken. De N47 brengt u rechtstreeks naar ons.',
    problemParagraph: 'Hamme is een landelijke gemeente met veel pendelaars richting Dendermonde, Gent of Antwerpen. Die pendeltrajekten zijn goed voor de motor, maar wie ook korte ritten maakt in de gemeente of regelmatig in de file staat op de N47, ziet zijn roetfilter geleidelijk verstoppen. Symptomen zoals vermogensverlies bij het optrekken of een brandend lampje zijn signalen die u niet mag negeren.',
    whyLokeren: 'Vanuit Hamme rijdt u via de N47 rechtstreeks naar Lokeren — 20 minuten en u staat bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter professioneel en testen het resultaat. U rijdt dezelfde dag terug naar Hamme met een gereinigde DPF en een volledig rapport.',
    trustParagraph: 'Klanten uit Hamme en omgeving waarderen onze persoonlijke aanpak. We nemen de tijd om alles uit te leggen en adviseren alleen wat echt nodig is. Met 12 jaar ervaring en 1 jaar garantie bent u bij ons in goede handen.',
    cta: 'Klant uit Hamme? Bel 0498 54 54 74 of vraag een gratis offerte aan via onze website.',
    faqs: [
      { q: 'Hoe kom ik vanuit Hamme naar Roetfilter Center?', a: 'Neem de N47 richting Lokeren. De rit duurt gemiddeld 20 minuten. Ons adres is Dijkstraat 22, 9160 Lokeren.' },
      { q: 'Mijn wagen verliest vermogen op de N47 — is dat de roetfilter?', a: 'Vermogensverlies is een klassiek symptoom van een verstopte roetfilter. Bel ons voor een diagnose. We lezen de foutcodes uit en bepalen de oorzaak.' },
      { q: 'Hoe lang ben ik mijn wagen kwijt?', a: 'Een volledige reiniging duurt gemiddeld 4 tot 6 uur. U kunt uw wagen dezelfde dag ophalen.' },
      { q: 'Wat kost een diagnose?', a: 'De diagnose kost €75. Dit bedrag wordt volledig terugbetaald als u bij ons een herstelling laat uitvoeren.' },
      { q: 'Werken jullie ook voor landbouwvoertuigen?', a: 'Neem contact op voor specifieke voertuigtypes. We behandelen een breed gamma aan dieselvoertuigen.' },
    ],
    nearbyCityLinks: ['lokeren', 'dendermonde', 'sint-niklaas', 'zele', 'waasmunster', 'temse', 'gent', 'aalst'],
  },
  {
    city: 'Zele',
    slug: 'zele',
    province: 'Oost-Vlaanderen',
    region: 'Scheldeland',
    priority: 1,
    driveTime: '10 minuten',
    driveMinutes: 10,
    nearbyTowns: ['Berlare', 'Wichelen', 'Wetteren', 'Laarne', 'Hamme'],
    highway: 'N47 / N9',
    seoTitle: 'Roetfilter Reinigen in Zele | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Zele. Slechts 10 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Gratis diagnose bij herstelling. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Zele',
    intro: 'Zele ligt vlak naast Lokeren — slechts 10 minuten rijden en u staat bij Roetfilter Center aan de deur. Als inwoner van Zele heeft u het voordeel van een erkende DPF-specialist letterlijk om de hoek. Geen lange rit, geen gedoe — gewoon snel en professioneel geholpen.',
    problemParagraph: 'Zele is een actieve gemeente met veel pendelaars en lokale ondernemers. Wie dagelijks rijdt via de N47 of N9, kent de files en de korte ritten. Die combinatie is funest voor de roetfilter. We zien bij klanten uit Zele regelmatig verstopte DPFs bij wagens die al een tijdje het lampje negeerden. Hoe langer u wacht, hoe groter de kans op schade.',
    whyLokeren: 'Vanuit Zele bent u in 10 minuten bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter en testen het resultaat. U rijdt dezelfde dag terug naar Zele met een gereinigde DPF en de zekerheid dat alles in orde is.',
    trustParagraph: 'Klanten uit Zele zijn trouwe klanten. Velen komen al jaren bij ons voor onderhoud en DPF-problemen. Onze nabijheid en betrouwbaarheid maken ons de logische keuze voor Zelenaars.',
    cta: 'Klant uit Zele? Bel 0498 54 54 74 of kom gewoon langs aan Dijkstraat 22, Lokeren.',
    faqs: [
      { q: 'Hoe ver is Zele van Roetfilter Center?', a: 'Zele ligt op slechts 10 minuten van onze werkplaats in Lokeren. Neem de N47 richting Lokeren.' },
      { q: 'Kan ik zonder afspraak langskomen vanuit Zele?', a: 'Voor een diagnose kunt u in veel gevallen dezelfde dag terecht. Voor een volledige reiniging raden we een afspraak aan. Bel ons op 0498 54 54 74.' },
      { q: 'Mijn roetfilterlampje brandt al weken — is dat erg?', a: 'Ja, wacht niet langer. Een lampje dat al weken brandt, betekent dat de filter ernstig verzadigd is. Hoe langer u wacht, hoe groter de kans op schade aan de filter of de motor.' },
      { q: 'Wat kost roetfilter reinigen voor een Volkswagen Golf?', a: 'Voor een personenwagen zoals een VW Golf kost reiniging €195–€250. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Bieden jullie ook een garantie?', a: 'Ja, wij geven 1 jaar garantie op elke roetfilter reiniging.' },
    ],
    nearbyCityLinks: ['lokeren', 'dendermonde', 'hamme', 'waasmunster', 'berlare', 'wetteren', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Waasmunster',
    slug: 'waasmunster',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 1,
    driveTime: '10 minuten',
    driveMinutes: 10,
    nearbyTowns: ['Hamme', 'Moerbeke', 'Lokeren', 'Zele', 'Eksaarde'],
    highway: 'N70 / N47',
    seoTitle: 'Roetfilter Reinigen in Waasmunster | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Waasmunster. Slechts 10 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Waasmunster',
    intro: 'Waasmunster grenst rechtstreeks aan Lokeren. Als inwoner van Waasmunster bent u in 10 minuten bij Roetfilter Center — de erkende DPF-specialist voor het Waasland. Geen lange rit, geen omwegen.',
    problemParagraph: 'Waasmunster is een landelijke gemeente met veel pendelaars richting Sint-Niklaas, Gent of Antwerpen. Wie dagelijks rijdt via de N70 of N47, kent de files en de korte ritten. Die combinatie zorgt voor een snellere verstopping van de roetfilter. Symptomen zoals vermogensverlies of een brandend lampje zijn signalen die u snel moet aanpakken.',
    whyLokeren: 'Vanuit Waasmunster bent u in 10 minuten bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter professioneel en geven u een volledig rapport mee. Snel, eerlijk en betrouwbaar.',
    trustParagraph: 'Klanten uit Waasmunster zijn trouwe klanten van Roetfilter Center. Onze nabijheid en betrouwbaarheid maken ons de logische keuze voor inwoners van Waasmunster en omgeving.',
    cta: 'Klant uit Waasmunster? Bel 0498 54 54 74 of kom langs aan Dijkstraat 22, Lokeren.',
    faqs: [
      { q: 'Hoe ver is Waasmunster van Roetfilter Center?', a: 'Waasmunster grenst aan Lokeren. De rit duurt gemiddeld 10 minuten.' },
      { q: 'Kan ik mijn wagen dezelfde dag laten reinigen?', a: 'In de meeste gevallen ja. Bel ons op 0498 54 54 74 om een afspraak in te plannen.' },
      { q: 'Wat zijn de symptomen van een verstopte roetfilter?', a: 'Brandend lampje, vermogensverlies, hoger brandstofverbruik, noodloop of een mislukte autokeuring door te hoge uitstoot.' },
      { q: 'Werken jullie ook voor bestelwagens?', a: 'Ja, we reinigen roetfilters van bestelwagens voor €250–€350.' },
      { q: 'Wat is de garantie op de reiniging?', a: '1 jaar garantie op elke roetfilter reiniging.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'hamme', 'zele', 'stekene', 'moerbeke', 'gent', 'dendermonde'],
  },
  // ─── OOST-VLAANDEREN — BEVEREN-KRUIBEKE-ZWIJNDRECHT ───────────────────────
  {
    city: 'Beveren-Kruibeke-Zwijndrecht',
    slug: 'beveren-kruibeke-zwijndrecht',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 1,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Melsele', 'Haasdonk', 'Kallo', 'Vrasene', 'Bazel', 'Rupelmonde'],
    highway: 'E17 / N70',
    seoTitle: 'Roetfilter Reinigen in Beveren-Kruibeke-Zwijndrecht | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Beveren, Kruibeke en Zwijndrecht. 20 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Beveren-Kruibeke-Zwijndrecht',
    intro: 'De fusiegemeente Beveren-Kruibeke-Zwijndrecht is een van de grootste gemeenten van het Waasland en ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Beveren, Melsele, Haasdonk, Kruibeke, Bazel en Zwijndrecht vinden bij Roetfilter Center een betrouwbare DPF-specialist.',
    problemParagraph: 'Beveren-Kruibeke-Zwijndrecht is een industriële gemeente met veel pendelaars en bedrijfsvoertuigen. Wie dagelijks rijdt via de E17 of N70, kent de files rond het Antwerpse havengebied. Die stop-and-go situaties zijn funest voor de roetfilter. Bovendien zien we bij klanten uit deze regio regelmatig problemen bij bestelwagens en bedrijfsvoertuigen die intensief worden ingezet.',
    whyLokeren: 'Vanuit Beveren rijdt u via de N70 of E17 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter professioneel en geven u een volledig rapport mee. We werken ook voor bedrijfsvloten.',
    trustParagraph: 'Klanten uit Beveren-Kruibeke-Zwijndrecht waarderen onze snelle service en eerlijke prijzen. We werken voor particulieren en bedrijven, van kleine personenwagens tot grote bestelwagens.',
    cta: 'Klant uit Beveren, Kruibeke of Zwijndrecht? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Beveren van Roetfilter Center?', a: 'Vanuit Beveren rijdt u via de N70 of E17 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Werken jullie ook voor bedrijfsvloten uit Beveren?', a: 'Ja, we werken voor bedrijfsvloten. Neem contact op voor onze B2B-tarieven en planningsopties.' },
      { q: 'Mijn bestelwagen heeft een verstopte DPF — wat kost dat?', a: 'Reiniging van een bestelwagen kost €250–€350. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
      { q: 'Werken jullie ook voor Antwerpse havenvoertuigen?', a: 'Neem contact op voor specifieke voertuigtypes en situaties. We behandelen een breed gamma aan dieselvoertuigen.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'temse', 'antwerpen', 'zwijndrecht', 'gent', 'dendermonde', 'hamme'],
  },
];

// ─── OOST-VLAANDEREN — ALL OTHER CITIES ────────────────────────────────────
const oostVlaanderenExtra: LocatieData[] = [
  {
    city: 'Evergem',
    slug: 'evergem',
    province: 'Oost-Vlaanderen',
    region: 'Gentse rand',
    priority: 2,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Zelzate', 'Wachtebeke', 'Sleidinge', 'Ertvelde', 'Desteldonk'],
    highway: 'R4 / N9',
    seoTitle: 'Roetfilter Reinigen in Evergem | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Evergem? Roetfilter Center in Lokeren reinigt uw DPF professioneel — inclusief diagnose, emissietest en 1 jaar garantie. Slechts 25 min.',
    h1: 'Roetfilter Reinigen in Evergem',
    intro: 'Evergem, gelegen in de Gentse rand langs het kanaal Gent-Terneuzen, ligt op 25 minuten van onze werkplaats in Lokeren. Klanten uit Evergem, Sleidinge, Ertvelde en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Evergem is een industriële gemeente met veel pendelaars richting Gent en het kanaalgebied. Wie dagelijks rijdt via de R4 of N9, kent de files en de stop-and-go situaties. Die rijstijl is funest voor de roetfilter. Bovendien zien we bij klanten uit Evergem regelmatig problemen bij bestelwagens die intensief worden ingezet in het industriegebied.',
    whyLokeren: 'Vanuit Evergem rijdt u via de R4 of N9 richting Lokeren. In 25 minuten staat u bij ons. We voeren een volledige diagnose uit en reinigen de roetfilter professioneel.',
    trustParagraph: 'Klanten uit Evergem en de Gentse rand waarderen onze snelle service en eerlijke prijzen. We werken voor particulieren en bedrijven.',
    cta: 'Klant uit Evergem? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Evergem van Roetfilter Center?', a: 'Vanuit Evergem rijdt u via de R4 of N9 naar Lokeren. De rit duurt gemiddeld 25 minuten.' },
      { q: 'Mijn bestelwagen heeft een verstopte DPF — wat kost dat?', a: 'Reiniging van een bestelwagen kost €250–€350. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
      { q: 'Wat zijn de symptomen van een verstopte roetfilter?', a: 'Brandend lampje, vermogensverlies, hoger brandstofverbruik of noodloop.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zelzate', 'wachtebeke', 'sint-niklaas', 'dendermonde', 'aalst', 'eeklo'],
  },
  {
    city: 'Deinze',
    slug: 'deinze',
    province: 'Oost-Vlaanderen',
    region: 'Leiestreek',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Nazareth-De Pinte', 'Zulte', 'Kruisem', 'Nevele', 'Aalter'],
    highway: 'N43 / E17',
    seoTitle: 'Roetfilter Reinigen in Deinze | Roetfilter Center',
    seoDescription: 'Roetfilter laten reinigen in Deinze of de Leiestreek? Roetfilter Center biedt DPF diagnose, reiniging en AdBlue hulp vanuit Lokeren. Snel geholpen, 35 min.',
    h1: 'Roetfilter Reinigen in Deinze',
    intro: 'Deinze, de fusiestad aan de Leie, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Deinze, Nazareth, Zulte en de ruime Leiestreek kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Deinze is een actieve stad met veel pendelaars richting Gent. Wie dagelijks rijdt via de N43 of E17, kent de files. Korte ritten in de stad en pendelen combineren is funest voor de roetfilter. We zien bij klanten uit Deinze regelmatig verstopte DPFs bij wagens die al een tijdje het lampje negeerden.',
    whyLokeren: 'Vanuit Deinze rijdt u via de N43 of E17 richting Lokeren. In 35 minuten staat u bij ons. We voeren een volledige diagnose uit en reinigen de roetfilter professioneel.',
    trustParagraph: 'Klanten uit Deinze en de Leiestreek waarderen onze transparante aanpak en eerlijke prijzen.',
    cta: 'Klant uit Deinze of de Leiestreek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Deinze van Roetfilter Center?', a: 'Vanuit Deinze rijdt u via de N43 of E17 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74. We plannen een afspraak in voor diagnose en reiniging.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'nazareth-de-pinte', 'zulte', 'kruisem', 'oudenaarde', 'sint-niklaas'],
  },
  {
    city: 'Wetteren',
    slug: 'wetteren',
    province: 'Oost-Vlaanderen',
    region: 'Scheldevallei',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Laarne', 'Wichelen', 'Berlare', 'Melle', 'Merelbeke-Melle'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Wetteren | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen in Wetteren of de Scheldevallei? Roetfilter Center in Lokeren lost DPF verstoppingen, noodloop en uitstootproblemen op. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Wetteren',
    intro: 'Wetteren, gelegen aan de Schelde tussen Gent en Aalst, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Wetteren, Laarne, Wichelen en de ruime Scheldevallei kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Wetteren is een pendelgemeente langs de E40. Wie dagelijks rijdt naar Gent of Brussel, rijdt weliswaar lange trajecten, maar de combinatie met korte ritten in de gemeente zorgt toch voor problemen. We zien bij klanten uit Wetteren regelmatig verstopte DPFs bij wagens die al een tijdje het lampje negeerden.',
    whyLokeren: 'Vanuit Wetteren rijdt u via de N9 of E40 richting Lokeren. In 20 minuten staat u bij ons. We voeren een volledige diagnose uit en reinigen de roetfilter professioneel.',
    trustParagraph: 'Klanten uit Wetteren en de Scheldevallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Wetteren? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Wetteren van Roetfilter Center?', a: 'Vanuit Wetteren rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn wagen is afgekeurd voor roet — wat nu?', a: 'Bel ons op 0498 54 54 74. Na reiniging voeren we een officiële emissietest uit. U krijgt een rapport mee voor de herkeuring.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'dendermonde', 'berlare', 'laarne', 'merelbeke-melle', 'zele'],
  },
  {
    city: 'Stekene',
    slug: 'stekene',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Kemzeke', 'Belsele', 'Sinaai', 'Moerbeke', 'Wachtebeke'],
    highway: 'N70 / N403',
    seoTitle: 'Roetfilter Reinigen in Stekene | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Stekene en het Waasland. Roetfilter Center in Lokeren: DPF diagnose, reiniging en 1 jaar garantie. Slechts 20 minuten.',
    h1: 'Roetfilter Reinigen in Stekene',
    intro: 'Stekene, gelegen in het hart van het Waasland, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Stekene, Kemzeke, Belsele en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Stekene is een landelijke gemeente met veel pendelaars richting Sint-Niklaas of Gent. Wie dagelijks rijdt via de N70 of N403, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Stekene rijdt u via de N70 of N403 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Stekene en het Waasland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Stekene? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Stekene van Roetfilter Center?', a: 'Vanuit Stekene rijdt u via de N70 of N403 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74. We plannen een afspraak in voor diagnose en reiniging.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'waasmunster', 'moerbeke', 'wachtebeke', 'gent', 'dendermonde', 'hamme'],
  },
  {
    city: 'Sint-Gillis-Waas',
    slug: 'sint-gillis-waas',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Meerdonk', 'Kieldrecht', 'Vrasene', 'Beveren-Kruibeke-Zwijndrecht', 'Sint-Niklaas'],
    highway: 'N70 / E34',
    seoTitle: 'Roetfilter Reinigen in Sint-Gillis-Waas | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Sint-Gillis-Waas? Roetfilter Center in Lokeren biedt professionele DPF reiniging, diagnose en AdBlue hulp. Snel en eerlijk geprijsd.',
    h1: 'Roetfilter Reinigen in Sint-Gillis-Waas',
    intro: 'Sint-Gillis-Waas, gelegen in het Waasland nabij de Nederlandse grens, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Sint-Gillis-Waas en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Sint-Gillis-Waas is een grensstreekgemeente met veel pendelaars en grensoverschrijdend verkeer. Wie dagelijks rijdt via de N70 of E34, kent de files. Die rijstijl is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Sint-Gillis-Waas rijdt u via de N70 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Sint-Gillis-Waas waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Sint-Gillis-Waas? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Sint-Gillis-Waas van Roetfilter Center?', a: 'Vanuit Sint-Gillis-Waas rijdt u via de N70 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'beveren-kruibeke-zwijndrecht', 'stekene', 'gent', 'antwerpen', 'temse', 'hamme'],
  },
  {
    city: 'Lochristi',
    slug: 'lochristi',
    province: 'Oost-Vlaanderen',
    region: 'Gentse rand',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Destelbergen', 'Beervelde', 'Zaffelare', 'Gent', 'Wachtebeke'],
    highway: 'N70 / E17',
    seoTitle: 'Roetfilter Reinigen in Lochristi | Roetfilter Center',
    seoDescription: 'Roetfilter lampje aan in Lochristi? Roetfilter Center in Lokeren reinigt uw DPF professioneel met diagnose voor én na. 20 min rijden, zelfde dag klaar.',
    h1: 'Roetfilter Reinigen in Lochristi',
    intro: 'Lochristi, de bloemengemeente in de Gentse rand, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Lochristi, Beervelde en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lochristi is een typische pendelgemeente. Wie dagelijks rijdt naar Gent via de N70 of E17, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lochristi rijdt u via de N70 of E17 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lochristi en de Gentse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lochristi? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lochristi van Roetfilter Center?', a: 'Vanuit Lochristi rijdt u via de N70 of E17 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'sint-niklaas', 'destelbergen', 'wachtebeke', 'dendermonde', 'aalst', 'evergem'],
  },
  {
    city: 'Destelbergen',
    slug: 'destelbergen',
    province: 'Oost-Vlaanderen',
    region: 'Gentse rand',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Gent', 'Laarne', 'Wetteren', 'Melle', 'Merelbeke-Melle'],
    highway: 'N9 / E17',
    seoTitle: 'Roetfilter Reinigen in Destelbergen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Destelbergen. Roetfilter Center in Lokeren: volledige DPF diagnose, reiniging en emissietest. 20 min, 1 jaar garantie.',
    h1: 'Roetfilter Reinigen in Destelbergen',
    intro: 'Destelbergen, gelegen in de Gentse rand aan de Schelde, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Destelbergen en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Destelbergen is een typische pendelgemeente. Wie dagelijks rijdt naar Gent via de N9 of E17, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Destelbergen rijdt u via de N9 of E17 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Destelbergen en de Gentse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Destelbergen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Destelbergen van Roetfilter Center?', a: 'Vanuit Destelbergen rijdt u via de N9 of E17 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'wetteren', 'laarne', 'merelbeke-melle', 'berlare', 'aalst', 'dendermonde'],
  },
  {
    city: 'Merelbeke-Melle',
    slug: 'merelbeke-melle',
    province: 'Oost-Vlaanderen',
    region: 'Gentse rand',
    priority: 2,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Gent', 'Destelbergen', 'De Pinte', 'Gavere', 'Wetteren'],
    highway: 'E17 / N9',
    seoTitle: 'Roetfilter Reinigen in Merelbeke-Melle | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Merelbeke of Melle? Roetfilter Center in Lokeren biedt DPF diagnose, reiniging en garantie. 25 minuten rijden, zelfde dag klaar.',
    h1: 'Roetfilter Reinigen in Merelbeke-Melle',
    intro: 'Merelbeke en Melle, gelegen in de Gentse rand langs de E17, liggen op 25 minuten van onze werkplaats in Lokeren. Klanten uit Merelbeke, Melle en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Merelbeke en Melle zijn typische pendelgemeenten. Wie dagelijks rijdt naar Gent via de E17 of N9, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Merelbeke of Melle rijdt u via de E17 of N9 rechtstreeks naar Lokeren. In 25 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Merelbeke-Melle en de Gentse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Merelbeke of Melle? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Merelbeke van Roetfilter Center?', a: 'Vanuit Merelbeke rijdt u via de E17 of N9 naar Lokeren. De rit duurt gemiddeld 25 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'destelbergen', 'wetteren', 'de-pinte', 'gavere', 'aalst', 'dendermonde'],
  },
  {
    city: 'Berlare',
    slug: 'berlare',
    province: 'Oost-Vlaanderen',
    region: 'Scheldevallei',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Zele', 'Wichelen', 'Wetteren', 'Laarne', 'Overmere'],
    highway: 'N445 / N9',
    seoTitle: 'Roetfilter Reinigen in Berlare | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Berlare? Roetfilter Center in Lokeren reinigt uw DPF vakkundig — diagnose, reiniging, emissietest en 1 jaar garantie. 20 min rijden.',
    h1: 'Roetfilter Reinigen in Berlare',
    intro: 'Berlare, de recreatiegemeente aan de Schelde, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Berlare, Overmere en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Berlare is een gemeente met veel pendelaars richting Gent of Aalst. Wie dagelijks rijdt via de N445 of N9, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Berlare rijdt u via de N445 of N9 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Berlare en de Scheldevallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Berlare? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Berlare van Roetfilter Center?', a: 'Vanuit Berlare rijdt u via de N445 of N9 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'zele', 'wetteren', 'laarne', 'dendermonde', 'gent', 'aalst', 'hamme'],
  },
  {
    city: 'Laarne',
    slug: 'laarne',
    province: 'Oost-Vlaanderen',
    region: 'Scheldevallei',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Wetteren', 'Berlare', 'Destelbergen', 'Gent', 'Melle'],
    highway: 'N9 / E17',
    seoTitle: 'Roetfilter Reinigen in Laarne | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Laarne en de Scheldevallei. Roetfilter Center in Lokeren: DPF diagnose, reiniging en garantie. Slechts 20 minuten rijden.',
    h1: 'Roetfilter Reinigen in Laarne',
    intro: 'Laarne, de kasteelgemeente aan de Schelde, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Laarne en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Laarne is een landelijke gemeente met veel pendelaars richting Gent. Wie dagelijks rijdt via de N9 of E17, kent de files. Korte ritten in de gemeente en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Laarne rijdt u via de N9 of E17 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Laarne en de Scheldevallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Laarne? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Laarne van Roetfilter Center?', a: 'Vanuit Laarne rijdt u via de N9 of E17 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'wetteren', 'berlare', 'destelbergen', 'merelbeke-melle', 'aalst', 'dendermonde'],
  },
  {
    city: 'Wichelen',
    slug: 'wichelen',
    province: 'Oost-Vlaanderen',
    region: 'Scheldevallei',
    priority: 2,
    driveTime: '20 minuten',
    driveMinutes: 20,
    nearbyTowns: ['Berlare', 'Wetteren', 'Laarne', 'Zele', 'Overmere'],
    highway: 'N445 / N9',
    seoTitle: 'Roetfilter Reinigen in Wichelen | Roetfilter Center',
    seoDescription: 'Roetfilter lampje brandt in Wichelen? Roetfilter Center in Lokeren biedt professionele DPF reiniging, diagnose en 1 jaar garantie. 20 min, zelfde dag klaar.',
    h1: 'Roetfilter Reinigen in Wichelen',
    intro: 'Wichelen, gelegen aan de Schelde, ligt op 20 minuten van onze werkplaats in Lokeren. Klanten uit Wichelen en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Wichelen is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N445 of N9, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Wichelen rijdt u via de N445 of N9 rechtstreeks naar Lokeren. In 20 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Wichelen en de Scheldevallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Wichelen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Wichelen van Roetfilter Center?', a: 'Vanuit Wichelen rijdt u via de N445 of N9 naar Lokeren. De rit duurt gemiddeld 20 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'berlare', 'wetteren', 'laarne', 'zele', 'dendermonde', 'gent', 'aalst'],
  },
  {
    city: 'Lebbeke',
    slug: 'lebbeke',
    province: 'Oost-Vlaanderen',
    region: 'Dendervallei',
    priority: 2,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Dendermonde', 'Buggenhout', 'Aalst', 'Hamme', 'Zele'],
    highway: 'N47 / N9',
    seoTitle: 'Roetfilter Reinigen in Lebbeke | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Lebbeke of de Dendervallei? Roetfilter Center in Lokeren: DPF diagnose, reiniging en EGR hulp. 25 minuten rijden, eerlijk geprijsd.',
    h1: 'Roetfilter Reinigen in Lebbeke',
    intro: 'Lebbeke, gelegen tussen Dendermonde en Aalst, ligt op 25 minuten van onze werkplaats in Lokeren. Klanten uit Lebbeke en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lebbeke is een pendelgemeente langs de N47. Wie dagelijks rijdt naar Dendermonde of Aalst, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lebbeke rijdt u via de N47 of N9 rechtstreeks naar Lokeren. In 25 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lebbeke en de Dendervallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lebbeke? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lebbeke van Roetfilter Center?', a: 'Vanuit Lebbeke rijdt u via de N47 of N9 naar Lokeren. De rit duurt gemiddeld 25 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'dendermonde', 'aalst', 'hamme', 'buggenhout', 'zele', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Buggenhout',
    slug: 'buggenhout',
    province: 'Oost-Vlaanderen',
    region: 'Dendervallei',
    priority: 2,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Dendermonde', 'Lebbeke', 'Hamme', 'Aalst', 'Opwijk'],
    highway: 'N47 / N9',
    seoTitle: 'Roetfilter Reinigen in Buggenhout | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Buggenhout? Roetfilter Center in Lokeren reinigt uw DPF professioneel met diagnose en emissietest. 25 minuten rijden, 1 jaar garantie.',
    h1: 'Roetfilter Reinigen in Buggenhout',
    intro: 'Buggenhout, gelegen in de Dendervallei, ligt op 25 minuten van onze werkplaats in Lokeren. Klanten uit Buggenhout en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Buggenhout is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N47 of N9, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Buggenhout rijdt u via de N47 of N9 rechtstreeks naar Lokeren. In 25 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Buggenhout en de Dendervallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Buggenhout? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Buggenhout van Roetfilter Center?', a: 'Vanuit Buggenhout rijdt u via de N47 of N9 naar Lokeren. De rit duurt gemiddeld 25 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'dendermonde', 'hamme', 'lebbeke', 'aalst', 'zele', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Moerbeke',
    slug: 'moerbeke',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 2,
    driveTime: '15 minuten',
    driveMinutes: 15,
    nearbyTowns: ['Wachtebeke', 'Stekene', 'Lokeren', 'Zelzate', 'Evergem'],
    highway: 'N403',
    seoTitle: 'Roetfilter Reinigen in Moerbeke | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Moerbeke? Roetfilter Center in Lokeren is uw dichtstbijzijnde DPF-specialist — diagnose, reiniging en garantie. Slechts 15 minuten.',
    h1: 'Roetfilter Reinigen in Moerbeke',
    intro: 'Moerbeke, gelegen in het Waasland nabij Lokeren, ligt op slechts 15 minuten van onze werkplaats. Klanten uit Moerbeke en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Moerbeke is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N403, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Moerbeke rijdt u via de N403 rechtstreeks naar Lokeren. In 15 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Moerbeke en het Waasland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Moerbeke? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Moerbeke van Roetfilter Center?', a: 'Vanuit Moerbeke rijdt u via de N403 naar Lokeren. De rit duurt gemiddeld 15 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'stekene', 'wachtebeke', 'zelzate', 'evergem', 'gent', 'waasmunster'],
  },
  {
    city: 'Wachtebeke',
    slug: 'wachtebeke',
    province: 'Oost-Vlaanderen',
    region: 'Waasland',
    priority: 2,
    driveTime: '15 minuten',
    driveMinutes: 15,
    nearbyTowns: ['Moerbeke', 'Zelzate', 'Evergem', 'Lokeren', 'Stekene'],
    highway: 'N403 / N9',
    seoTitle: 'Roetfilter Reinigen in Wachtebeke | Roetfilter Center',
    seoDescription: 'Roetfilter lampje aan in Wachtebeke? Roetfilter Center in Lokeren biedt DPF diagnose, reiniging en 1 jaar garantie. 15 minuten rijden, zelfde dag geholpen.',
    h1: 'Roetfilter Reinigen in Wachtebeke',
    intro: 'Wachtebeke, gelegen in het Waasland nabij Lokeren, ligt op slechts 15 minuten van onze werkplaats. Klanten uit Wachtebeke en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Wachtebeke is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N403 of N9, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Wachtebeke rijdt u via de N403 of N9 rechtstreeks naar Lokeren. In 15 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Wachtebeke en het Waasland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Wachtebeke? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Wachtebeke van Roetfilter Center?', a: 'Vanuit Wachtebeke rijdt u via de N403 of N9 naar Lokeren. De rit duurt gemiddeld 15 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'sint-niklaas', 'moerbeke', 'stekene', 'zelzate', 'evergem', 'gent', 'waasmunster'],
  },
  {
    city: 'Zelzate',
    slug: 'zelzate',
    province: 'Oost-Vlaanderen',
    region: 'Kanaalzone',
    priority: 2,
    driveTime: '25 minuten',
    driveMinutes: 25,
    nearbyTowns: ['Evergem', 'Wachtebeke', 'Assenede', 'Eeklo', 'Gent'],
    highway: 'N9',
    seoTitle: 'Roetfilter Reinigen in Zelzate | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen in Zelzate of de Kanaalzone? Roetfilter Center in Lokeren: DPF diagnose, reiniging voor bestelwagens en personenwagens. 25 min rijden.',
    h1: 'Roetfilter Reinigen in Zelzate',
    intro: 'Zelzate, de industriegemeente aan het kanaal Gent-Terneuzen, ligt op 25 minuten van onze werkplaats in Lokeren. Klanten uit Zelzate en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Zelzate is een industriële gemeente met veel bedrijfsvoertuigen en pendelaars. Wie dagelijks rijdt via de N9, kent de files. Industrieel gebruik en korte ritten combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Zelzate rijdt u via de N9 rechtstreeks naar Lokeren. In 25 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Zelzate en de Kanaalzone waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Zelzate? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Zelzate van Roetfilter Center?', a: 'Vanuit Zelzate rijdt u via de N9 naar Lokeren. De rit duurt gemiddeld 25 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'evergem', 'wachtebeke', 'assenede', 'eeklo', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Eeklo',
    slug: 'eeklo',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Kaprijke', 'Assenede', 'Maldegem', 'Aalter', 'Evergem'],
    highway: 'N9 / N49',
    seoTitle: 'Roetfilter Reinigen in Eeklo | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Eeklo of het Meetjesland? Roetfilter Center in Lokeren biedt DPF diagnose, reiniging en AdBlue hulp. 35 min, 1 jaar garantie.',
    h1: 'Roetfilter Reinigen in Eeklo',
    intro: 'Eeklo, de hoofdstad van het Meetjesland, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Eeklo, Kaprijke, Assenede en het ruime Meetjesland kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Eeklo is een actieve stad met veel pendelaars richting Gent. Wie dagelijks rijdt via de N9 of N49, kent de files. Korte ritten in de stad en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Eeklo rijdt u via de N9 of N49 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Eeklo en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Eeklo of het Meetjesland? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Eeklo van Roetfilter Center?', a: 'Vanuit Eeklo rijdt u via de N9 of N49 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zelzate', 'evergem', 'assenede', 'kaprijke', 'maldegem', 'sint-niklaas'],
  },
  {
    city: 'Assenede',
    slug: 'assenede',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Zelzate', 'Evergem', 'Kaprijke', 'Eeklo', 'Gent'],
    highway: 'N9',
    seoTitle: 'Roetfilter Reinigen in Assenede | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Assenede? Roetfilter Center in Lokeren reinigt uw DPF vakkundig — diagnose, reiniging en emissietest. 35 minuten rijden, eerlijk tarief.',
    h1: 'Roetfilter Reinigen in Assenede',
    intro: 'Assenede, gelegen in het Meetjesland, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Assenede en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Assenede is een landelijke gemeente met veel pendelaars richting Gent. Wie dagelijks rijdt via de N9, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Assenede rijdt u via de N9 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Assenede en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Assenede? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Assenede van Roetfilter Center?', a: 'Vanuit Assenede rijdt u via de N9 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zelzate', 'evergem', 'eeklo', 'kaprijke', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Kaprijke',
    slug: 'kaprijke',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Eeklo', 'Assenede', 'Zelzate', 'Evergem', 'Maldegem'],
    highway: 'N9 / N49',
    seoTitle: 'Roetfilter Reinigen in Kaprijke | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Kaprijke of het Meetjesland? Roetfilter Center in Lokeren: professionele DPF reiniging, diagnose en 1 jaar garantie. 35 min rijden.',
    h1: 'Roetfilter Reinigen in Kaprijke',
    intro: 'Kaprijke, gelegen in het Meetjesland, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Kaprijke en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Kaprijke is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N9 of N49, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Kaprijke rijdt u via de N9 of N49 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Kaprijke en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Kaprijke? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Kaprijke van Roetfilter Center?', a: 'Vanuit Kaprijke rijdt u via de N9 of N49 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'eeklo', 'assenede', 'zelzate', 'evergem', 'maldegem', 'sint-niklaas'],
  },
  {
    city: 'Maldegem',
    slug: 'maldegem',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Eeklo', 'Aalter', 'Kaprijke', 'Lievegem', 'Evergem'],
    highway: 'N9 / N49',
    seoTitle: 'Roetfilter Reinigen in Maldegem | Roetfilter Center',
    seoDescription: 'Roetfilter lampje brandt in Maldegem? Roetfilter Center in Lokeren biedt DPF diagnose, reiniging en garantie. 45 minuten rijden — zelfde dag klaar, eerlijk tarief.',
    h1: 'Roetfilter Reinigen in Maldegem',
    intro: 'Maldegem, gelegen in het Meetjesland, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Maldegem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Maldegem is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N9 of N49, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Maldegem rijdt u via de N9 of N49 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Maldegem en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Maldegem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Maldegem van Roetfilter Center?', a: 'Vanuit Maldegem rijdt u via de N9 of N49 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'eeklo', 'kaprijke', 'assenede', 'aalter', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Lievegem',
    slug: 'lievegem',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Evergem', 'Aalter', 'Maldegem', 'Gent', 'Zelzate'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Lievegem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Lievegem? Roetfilter Center in Lokeren: DPF diagnose, reiniging en AdBlue hulp voor diesel rijders. 30 minuten, 1 jaar garantie.',
    h1: 'Roetfilter Reinigen in Lievegem',
    intro: 'Lievegem, de fusiegemeente in het Meetjesland, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Lievegem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lievegem is een landelijke gemeente met veel pendelaars richting Gent. Wie dagelijks rijdt via de N9 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lievegem rijdt u via de N9 of E40 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lievegem en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lievegem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lievegem van Roetfilter Center?', a: 'Vanuit Lievegem rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'evergem', 'aalter', 'maldegem', 'zelzate', 'eeklo', 'sint-niklaas'],
  },
  {
    city: 'Aalter',
    slug: 'aalter',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Maldegem', 'Eeklo', 'Deinze', 'Lievegem', 'Knesselare'],
    highway: 'E40 / N9',
    seoTitle: 'Roetfilter Reinigen in Aalter | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Aalter? Roetfilter Center in Lokeren biedt professionele DPF reiniging, diagnose en emissietest. 40 minuten rijden, zelfde dag klaar.',
    h1: 'Roetfilter Reinigen in Aalter',
    intro: 'Aalter, gelegen langs de E40, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Aalter en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Aalter is een pendelgemeente langs de E40. Wie dagelijks rijdt naar Gent of Brugge, rijdt weliswaar lange trajecten, maar de combinatie met korte ritten in de gemeente zorgt toch voor problemen.',
    whyLokeren: 'Vanuit Aalter rijdt u via de E40 of N9 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Aalter en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Aalter? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Aalter van Roetfilter Center?', a: 'Vanuit Aalter rijdt u via de E40 of N9 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'maldegem', 'eeklo', 'deinze', 'lievegem', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Nazareth-De Pinte',
    slug: 'nazareth-de-pinte',
    province: 'Oost-Vlaanderen',
    region: 'Leiestreek',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Deinze', 'Zulte', 'Gavere', 'Merelbeke-Melle', 'Gent'],
    highway: 'E17 / N60',
    seoTitle: 'Roetfilter Reinigen in Nazareth-De Pinte | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Nazareth of De Pinte? Roetfilter Center in Lokeren: DPF diagnose, reiniging en garantie voor alle merken. 30 minuten rijden.',
    h1: 'Roetfilter Reinigen in Nazareth-De Pinte',
    intro: 'Nazareth en De Pinte, gelegen in de Leiestreek, liggen op 30 minuten van onze werkplaats in Lokeren. Klanten uit Nazareth, De Pinte en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Nazareth en De Pinte zijn typische pendelgemeenten. Wie dagelijks rijdt naar Gent via de E17 of N60, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Nazareth of De Pinte rijdt u via de E17 of N60 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Nazareth-De Pinte en de Leiestreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Nazareth of De Pinte? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Nazareth van Roetfilter Center?', a: 'Vanuit Nazareth rijdt u via de E17 of N60 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'deinze', 'zulte', 'gavere', 'merelbeke-melle', 'aalst', 'dendermonde'],
  },
  {
    city: 'Zulte',
    slug: 'zulte',
    province: 'Oost-Vlaanderen',
    region: 'Leiestreek',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Deinze', 'Kruisem', 'Waregem', 'Nazareth-De Pinte', 'Gavere'],
    highway: 'E17 / N43',
    seoTitle: 'Roetfilter Reinigen in Zulte | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen vanuit Zulte of de Leiestreek? Roetfilter Center in Lokeren biedt DPF diagnose, reiniging en 1 jaar garantie. 40 minuten, zelfde dag klaar.',
    h1: 'Roetfilter Reinigen in Zulte',
    intro: 'Zulte, gelegen in de Leiestreek, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Zulte en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Zulte is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de E17 of N43, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Zulte rijdt u via de E17 of N43 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Zulte en de Leiestreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Zulte? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Zulte van Roetfilter Center?', a: 'Vanuit Zulte rijdt u via de E17 of N43 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'deinze', 'kruisem', 'nazareth-de-pinte', 'gavere', 'aalst', 'dendermonde'],
  },
  {
    city: 'Kruisem',
    slug: 'kruisem',
    province: 'Oost-Vlaanderen',
    region: 'Leiestreek',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Zulte', 'Gavere', 'Oudenaarde', 'Deinze', 'Wortegem-Petegem'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Kruisem | Roetfilter Center',
    seoDescription: 'Roetfilter verstopt in Kruisem? Roetfilter Center in Lokeren reinigt uw DPF vakkundig — diagnose, reiniging en emissietest. 45 minuten rijden, eerlijk tarief.',
    h1: 'Roetfilter Reinigen in Kruisem',
    intro: 'Kruisem, gelegen in de Leiestreek, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Kruisem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Kruisem is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Kruisem rijdt u via de N60 of E17 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Kruisem en de Leiestreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Kruisem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Kruisem van Roetfilter Center?', a: 'Vanuit Kruisem rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zulte', 'gavere', 'oudenaarde', 'deinze', 'aalst', 'dendermonde'],
  },
  {
    city: 'Gavere',
    slug: 'gavere',
    province: 'Oost-Vlaanderen',
    region: 'Scheldevallei',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Nazareth-De Pinte', 'Kruisem', 'Oudenaarde', 'Merelbeke-Melle', 'Gent'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Gavere | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Gavere. 35 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Gavere',
    intro: 'Gavere, gelegen aan de Schelde, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Gavere en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Gavere is een landelijke gemeente met veel pendelaars richting Gent. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Gavere rijdt u via de N60 of E17 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Gavere en de Scheldevallei waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Gavere? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Gavere van Roetfilter Center?', a: 'Vanuit Gavere rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'nazareth-de-pinte', 'kruisem', 'oudenaarde', 'merelbeke-melle', 'aalst', 'dendermonde'],
  },
  {
    city: 'Oudenaarde',
    slug: 'oudenaarde',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Ronse', 'Kruisem', 'Gavere', 'Wortegem-Petegem', 'Maarkedal'],
    highway: 'E17 / N60',
    seoTitle: 'Roetfilter Reinigen in Oudenaarde | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Oudenaarde en de Vlaamse Ardennen. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Oudenaarde',
    intro: 'Oudenaarde, de stad aan de Schelde in de Vlaamse Ardennen, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Oudenaarde, Ronse en de ruime Vlaamse Ardennen kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Oudenaardse automobilisten rijden vaak via de E17 of N60 voor dagelijkse verplaatsingen. Wie pendelt naar Gent of Kortrijk, rijdt weliswaar lange trajecten, maar wie ook korte ritten maakt in de stad, ziet zijn roetfilter geleidelijk verstoppen. Bovendien zien we bij klanten uit de Vlaamse Ardennen regelmatig problemen bij wagens die veel heuvelachtig terrein rijden.',
    whyLokeren: 'Vanuit Oudenaarde rijdt u via de E17 of N60 richting Lokeren. In 50 minuten staat u bij ons. We voeren een volledige diagnose uit en reinigen de roetfilter professioneel.',
    trustParagraph: 'Klanten uit Oudenaarde en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Oudenaarde of de Vlaamse Ardennen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Oudenaarde van Roetfilter Center?', a: 'Vanuit Oudenaarde rijdt u via de E17 of N60 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'ronse', 'kruisem', 'gavere', 'aalst', 'dendermonde', 'sint-niklaas'],
  },
  {
    city: 'Ronse',
    slug: 'ronse',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '60 minuten',
    driveMinutes: 60,
    nearbyTowns: ['Maarkedal', 'Kluisbergen', 'Oudenaarde', 'Brakel', 'Geraardsbergen'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Ronse | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ronse. 60 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ronse',
    intro: 'Ronse, de stad in de Vlaamse Ardennen, ligt op 60 minuten van onze werkplaats in Lokeren. Klanten uit Ronse en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ronse is een stad met veel pendelaars. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Ronse rijdt u via de N60 of E17 richting Lokeren. In 60 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ronse en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ronse? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ronse van Roetfilter Center?', a: 'Vanuit Ronse rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 60 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'oudenaarde', 'maarkedal', 'kluisbergen', 'brakel', 'geraardsbergen', 'aalst'],
  },
  {
    city: 'Geraardsbergen',
    slug: 'geraardsbergen',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Brakel', 'Lierde', 'Zottegem', 'Ronse', 'Ninove'],
    highway: 'E40 / N42',
    seoTitle: 'Roetfilter Reinigen in Geraardsbergen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Geraardsbergen. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Geraardsbergen',
    intro: 'Geraardsbergen, de stad van de Muur, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Geraardsbergen en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Geraardsbergen is een stad met veel pendelaars. Wie dagelijks rijdt via de E40 of N42, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Geraardsbergen rijdt u via de E40 of N42 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Geraardsbergen en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Geraardsbergen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Geraardsbergen van Roetfilter Center?', a: 'Vanuit Geraardsbergen rijdt u via de E40 of N42 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'brakel', 'lierde', 'zottegem', 'ronse', 'ninove', 'aalst'],
  },
  {
    city: 'Zottegem',
    slug: 'zottegem',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Herzele', 'Lierde', 'Brakel', 'Gavere', 'Kruisem'],
    highway: 'N42 / E40',
    seoTitle: 'Roetfilter Reinigen in Zottegem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Zottegem. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Zottegem',
    intro: 'Zottegem, gelegen in de Vlaamse Ardennen, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Zottegem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Zottegem is een stad met veel pendelaars. Wie dagelijks rijdt via de N42 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Zottegem rijdt u via de N42 of E40 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Zottegem en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Zottegem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Zottegem van Roetfilter Center?', a: 'Vanuit Zottegem rijdt u via de N42 of E40 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'herzele', 'lierde', 'brakel', 'gavere', 'aalst', 'dendermonde'],
  },
  {
    city: 'Ninove',
    slug: 'ninove',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Geraardsbergen', 'Aalst', 'Liedekerke', 'Herzele', 'Denderleeuw'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Ninove | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ninove en de Denderstreek. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ninove',
    intro: 'Ninove, gelegen in de Denderstreek, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Ninove en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ninove is een stad met veel pendelaars richting Brussel of Gent via de E40. Wie dagelijks rijdt via de N9 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Ninove rijdt u via de N9 of E40 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ninove en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ninove? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ninove van Roetfilter Center?', a: 'Vanuit Ninove rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'geraardsbergen', 'herzele', 'denderleeuw', 'dendermonde', 'sint-niklaas'],
  },
  {
    city: 'Herzele',
    slug: 'herzele',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Zottegem', 'Ninove', 'Aalst', 'Lierde', 'Brakel'],
    highway: 'N42 / E40',
    seoTitle: 'Roetfilter Reinigen in Herzele | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Herzele. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Herzele',
    intro: 'Herzele, gelegen in de Denderstreek, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Herzele en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Herzele is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N42 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Herzele rijdt u via de N42 of E40 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Herzele en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Herzele? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Herzele van Roetfilter Center?', a: 'Vanuit Herzele rijdt u via de N42 of E40 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zottegem', 'ninove', 'aalst', 'lierde', 'brakel', 'dendermonde'],
  },
  {
    city: 'Erpe-Mere',
    slug: 'erpe-mere',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Aalst', 'Herzele', 'Ninove', 'Haaltert', 'Lede'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Erpe-Mere | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Erpe-Mere. 35 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Erpe-Mere',
    intro: 'Erpe-Mere, gelegen in de Denderstreek, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Erpe-Mere en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Erpe-Mere is een pendelgemeente langs de N9. Wie dagelijks rijdt naar Aalst of Gent, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Erpe-Mere rijdt u via de N9 of E40 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Erpe-Mere en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Erpe-Mere? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Erpe-Mere van Roetfilter Center?', a: 'Vanuit Erpe-Mere rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'herzele', 'ninove', 'haaltert', 'lede', 'dendermonde'],
  },
  {
    city: 'Haaltert',
    slug: 'haaltert',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Aalst', 'Erpe-Mere', 'Lede', 'Denderleeuw', 'Ninove'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Haaltert | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Haaltert. 35 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Haaltert',
    intro: 'Haaltert, gelegen in de Denderstreek, ligt op 35 minuten van onze werkplaats in Lokeren. Klanten uit Haaltert en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Haaltert is een pendelgemeente. Wie dagelijks rijdt via de N9 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Haaltert rijdt u via de N9 of E40 richting Lokeren. In 35 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Haaltert en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Haaltert? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Haaltert van Roetfilter Center?', a: 'Vanuit Haaltert rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 35 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'erpe-mere', 'lede', 'denderleeuw', 'ninove', 'dendermonde'],
  },
  {
    city: 'Lede',
    slug: 'lede',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Aalst', 'Haaltert', 'Erpe-Mere', 'Wetteren', 'Melle'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Lede | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Lede. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Lede',
    intro: 'Lede, gelegen in de Denderstreek, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Lede en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lede is een pendelgemeente. Wie dagelijks rijdt via de N9 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lede rijdt u via de N9 of E40 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lede en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lede? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lede van Roetfilter Center?', a: 'Vanuit Lede rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'haaltert', 'erpe-mere', 'wetteren', 'merelbeke-melle', 'dendermonde'],
  },
  {
    city: 'Denderleeuw',
    slug: 'denderleeuw',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Aalst', 'Haaltert', 'Ninove', 'Liedekerke', 'Geraardsbergen'],
    highway: 'N9 / E40',
    seoTitle: 'Roetfilter Reinigen in Denderleeuw | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Denderleeuw. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Denderleeuw',
    intro: 'Denderleeuw, gelegen in de Denderstreek, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Denderleeuw en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Denderleeuw is een pendelgemeente langs de N9. Wie dagelijks rijdt naar Aalst of Brussel, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Denderleeuw rijdt u via de N9 of E40 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Denderleeuw en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Denderleeuw? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Denderleeuw van Roetfilter Center?', a: 'Vanuit Denderleeuw rijdt u via de N9 of E40 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'aalst', 'haaltert', 'ninove', 'liedekerke', 'geraardsbergen', 'dendermonde'],
  },
  {
    city: 'Brakel',
    slug: 'brakel',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Zottegem', 'Geraardsbergen', 'Ronse', 'Lierde', 'Horebeke'],
    highway: 'N42 / E17',
    seoTitle: 'Roetfilter Reinigen in Brakel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Brakel. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Brakel',
    intro: 'Brakel, gelegen in de Vlaamse Ardennen, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Brakel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Brakel is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N42 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Brakel rijdt u via de N42 of E17 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Brakel en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Brakel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Brakel van Roetfilter Center?', a: 'Vanuit Brakel rijdt u via de N42 of E17 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zottegem', 'geraardsbergen', 'ronse', 'lierde', 'horebeke', 'aalst'],
  },
  {
    city: 'Lierde',
    slug: 'lierde',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Zottegem', 'Brakel', 'Geraardsbergen', 'Ronse', 'Ninove'],
    highway: 'N42 / E40',
    seoTitle: 'Roetfilter Reinigen in Lierde | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Lierde. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Lierde',
    intro: 'Lierde, gelegen in de Vlaamse Ardennen, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Lierde en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lierde is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N42 of E40, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lierde rijdt u via de N42 of E40 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lierde en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lierde? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lierde van Roetfilter Center?', a: 'Vanuit Lierde rijdt u via de N42 of E40 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zottegem', 'brakel', 'geraardsbergen', 'ronse', 'ninove', 'aalst'],
  },
  {
    city: 'Horebeke',
    slug: 'horebeke',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '60 minuten',
    driveMinutes: 60,
    nearbyTowns: ['Brakel', 'Ronse', 'Maarkedal', 'Kluisbergen', 'Oudenaarde'],
    highway: 'N42 / E17',
    seoTitle: 'Roetfilter Reinigen in Horebeke | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Horebeke. 60 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Horebeke',
    intro: 'Horebeke, gelegen in de Vlaamse Ardennen, ligt op 60 minuten van onze werkplaats in Lokeren. Klanten uit Horebeke en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Horebeke is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N42 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Horebeke rijdt u via de N42 of E17 richting Lokeren. In 60 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Horebeke en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Horebeke? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Horebeke van Roetfilter Center?', a: 'Vanuit Horebeke rijdt u via de N42 of E17 naar Lokeren. De rit duurt gemiddeld 60 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'brakel', 'ronse', 'maarkedal', 'kluisbergen', 'oudenaarde', 'aalst'],
  },
  {
    city: 'Maarkedal',
    slug: 'maarkedal',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Ronse', 'Kluisbergen', 'Oudenaarde', 'Brakel', 'Horebeke'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Maarkedal | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Maarkedal. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Maarkedal',
    intro: 'Maarkedal, gelegen in de Vlaamse Ardennen, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Maarkedal en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Maarkedal is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Maarkedal rijdt u via de N60 of E17 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Maarkedal en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Maarkedal? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Maarkedal van Roetfilter Center?', a: 'Vanuit Maarkedal rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'ronse', 'kluisbergen', 'oudenaarde', 'brakel', 'horebeke', 'aalst'],
  },
  {
    city: 'Kluisbergen',
    slug: 'kluisbergen',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '60 minuten',
    driveMinutes: 60,
    nearbyTowns: ['Ronse', 'Maarkedal', 'Oudenaarde', 'Wortegem-Petegem', 'Avelgem'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Kluisbergen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Kluisbergen. 60 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Kluisbergen',
    intro: 'Kluisbergen, gelegen in de Vlaamse Ardennen, ligt op 60 minuten van onze werkplaats in Lokeren. Klanten uit Kluisbergen en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Kluisbergen is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Kluisbergen rijdt u via de N60 of E17 richting Lokeren. In 60 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Kluisbergen en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Kluisbergen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Kluisbergen van Roetfilter Center?', a: 'Vanuit Kluisbergen rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 60 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'ronse', 'maarkedal', 'oudenaarde', 'wortegem-petegem', 'aalst', 'dendermonde'],
  },
  {
    city: 'Wortegem-Petegem',
    slug: 'wortegem-petegem',
    province: 'Oost-Vlaanderen',
    region: 'Vlaamse Ardennen',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Oudenaarde', 'Kruisem', 'Gavere', 'Kluisbergen', 'Deinze'],
    highway: 'N60 / E17',
    seoTitle: 'Roetfilter Reinigen in Wortegem-Petegem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Wortegem-Petegem. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Wortegem-Petegem',
    intro: 'Wortegem-Petegem, gelegen in de Vlaamse Ardennen, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Wortegem-Petegem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Wortegem-Petegem is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N60 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Wortegem-Petegem rijdt u via de N60 of E17 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Wortegem-Petegem en de Vlaamse Ardennen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Wortegem-Petegem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Wortegem-Petegem van Roetfilter Center?', a: 'Vanuit Wortegem-Petegem rijdt u via de N60 of E17 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'oudenaarde', 'kruisem', 'gavere', 'kluisbergen', 'aalst', 'dendermonde'],
  },
  {
    city: 'Sint-Lievens-Houtem',
    slug: 'sint-lievens-houtem',
    province: 'Oost-Vlaanderen',
    region: 'Denderstreek',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Zottegem', 'Herzele', 'Aalst', 'Lede', 'Wetteren'],
    highway: 'N42 / N9',
    seoTitle: 'Roetfilter Reinigen in Sint-Lievens-Houtem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Sint-Lievens-Houtem. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Sint-Lievens-Houtem',
    intro: 'Sint-Lievens-Houtem, gelegen in de Denderstreek, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Sint-Lievens-Houtem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Sint-Lievens-Houtem is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N42 of N9, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Sint-Lievens-Houtem rijdt u via de N42 of N9 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Sint-Lievens-Houtem en de Denderstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Sint-Lievens-Houtem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Sint-Lievens-Houtem van Roetfilter Center?', a: 'Vanuit Sint-Lievens-Houtem rijdt u via de N42 of N9 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'zottegem', 'herzele', 'aalst', 'lede', 'wetteren', 'dendermonde'],
  },
  {
    city: 'Sint-Martens-Latem',
    slug: 'sint-martens-latem',
    province: 'Oost-Vlaanderen',
    region: 'Leiestreek',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Deinze', 'Gent', 'Nazareth-De Pinte', 'Gavere', 'Merelbeke-Melle'],
    highway: 'E17 / N43',
    seoTitle: 'Roetfilter Reinigen in Sint-Martens-Latem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Sint-Martens-Latem. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Sint-Martens-Latem',
    intro: 'Sint-Martens-Latem, de kunstenaarsgemeente aan de Leie, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Sint-Martens-Latem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Sint-Martens-Latem is een welgestelde gemeente met veel pendelaars richting Gent. Wie dagelijks rijdt via de E17 of N43, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Sint-Martens-Latem rijdt u via de E17 of N43 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Sint-Martens-Latem en de Leiestreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Sint-Martens-Latem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Sint-Martens-Latem van Roetfilter Center?', a: 'Vanuit Sint-Martens-Latem rijdt u via de E17 of N43 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'deinze', 'nazareth-de-pinte', 'gavere', 'merelbeke-melle', 'aalst', 'dendermonde'],
  },
  {
    city: 'Oosterzele',
    slug: 'oosterzele',
    province: 'Oost-Vlaanderen',
    region: 'Gentse rand',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Merelbeke-Melle', 'Gent', 'Zottegem', 'Herzele', 'Gavere'],
    highway: 'N42 / E17',
    seoTitle: 'Roetfilter Reinigen in Oosterzele | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Oosterzele. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Oosterzele',
    intro: 'Oosterzele, gelegen in de Gentse rand, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Oosterzele en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Oosterzele is een pendelgemeente. Wie dagelijks rijdt via de N42 of E17, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Oosterzele rijdt u via de N42 of E17 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Oosterzele en de Gentse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Oosterzele? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Oosterzele van Roetfilter Center?', a: 'Vanuit Oosterzele rijdt u via de N42 of E17 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'merelbeke-melle', 'zottegem', 'herzele', 'gavere', 'aalst', 'dendermonde'],
  },
  {
    city: 'Sint-Laureins',
    slug: 'sint-laureins',
    province: 'Oost-Vlaanderen',
    region: 'Meetjesland',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Assenede', 'Eeklo', 'Kaprijke', 'Maldegem', 'Zelzate'],
    highway: 'N9 / N49',
    seoTitle: 'Roetfilter Reinigen in Sint-Laureins | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Sint-Laureins. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Sint-Laureins',
    intro: 'Sint-Laureins, gelegen in het Meetjesland, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Sint-Laureins en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Sint-Laureins is een landelijke gemeente met veel pendelaars. Wie dagelijks rijdt via de N9 of N49, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Sint-Laureins rijdt u via de N9 of N49 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Sint-Laureins en het Meetjesland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Sint-Laureins? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Sint-Laureins van Roetfilter Center?', a: 'Vanuit Sint-Laureins rijdt u via de N9 of N49 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'assenede', 'eeklo', 'kaprijke', 'maldegem', 'zelzate', 'sint-niklaas'],
  },
];

export { oostVlaanderenExtra };

// ─── ANTWERPEN CITIES ──────────────────────────────────────────────────────
const antwerpenCities: LocatieData[] = [
  {
    city: 'Antwerpen',
    slug: 'antwerpen',
    province: 'Antwerpen',
    region: 'Antwerpen',
    priority: 1,
    driveTime: '35 minuten',
    driveMinutes: 35,
    nearbyTowns: ['Berchem', 'Borgerhout', 'Deurne', 'Merksem', 'Hoboken', 'Wilrijk'],
    highway: 'E17 / R1',
    seoTitle: 'Roetfilter Reinigen in Antwerpen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen in Antwerpen? Kom naar Roetfilter Center in Lokeren voor professionele DPF diagnose, reiniging en hulp bij roetfilter lampjes, noodloop en afgekeurde keuring. LEZ-conform. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Antwerpen',
    intro: 'Antwerpen, de grootste stad van Vlaanderen, heeft een van de strengste lage-emissiezones van België. Klanten uit Antwerpen, Berchem, Deurne en de ruime Antwerpse regio rijden dagelijks naar onze werkplaats in Lokeren — slechts 35 minuten via de E17. Roetfilter Center is de erkende DPF-specialist voor de volledige Antwerpse regio.',
    problemParagraph: 'Antwerpenaren rijden dagelijks in een van de drukste verkeersgebieden van Europa. De R1, de E17, de E19 en de E313 zijn dagelijks verstopt. Stop-and-go verkeer, korte stadsritten en de druk van de LEZ zorgen ervoor dat roetfilters sneller verstoppen dan gemiddeld. Bovendien riskeren Antwerpenaren met een niet-conforme wagen een boete bij het betreden van de lage-emissiezone.',
    whyLokeren: 'Vanuit Antwerpen rijdt u via de E17 richting Gent en neemt u de afrit Lokeren. In 35 minuten staat u bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter professioneel en testen het resultaat met een officiële emissietest. Na reiniging voldoet uw wagen opnieuw aan de LEZ-normen.',
    trustParagraph: 'Klanten uit Antwerpen kiezen voor Roetfilter Center omdat we snelle service, transparante communicatie en bewezen resultaten combineren. We werken met alle merken — van Volkswagen en BMW tot Mercedes en Audi. Onze technici kennen de DPF-problematiek van Antwerpse stadsrijders door en door.',
    cta: 'Klant uit Antwerpen? Bel 0498 54 54 74 of vraag een gratis offerte aan. Wij helpen u dezelfde dag.',
    faqs: [
      { q: 'Hoe ver is Antwerpen van Roetfilter Center in Lokeren?', a: 'Vanuit Antwerpen rijdt u via de E17 richting Gent en neemt u de afrit Lokeren. De rit duurt gemiddeld 35 minuten buiten de spits.' },
      { q: 'Helpt roetfilter reiniging bij LEZ-problemen in Antwerpen?', a: 'Ja, een gereinigde roetfilter zorgt voor lagere uitstoot en helpt u voldoen aan de LEZ-normen. Na reiniging voeren wij een officiële emissietest uit.' },
      { q: 'Mijn wagen gaat in noodloop in Antwerpen — wat nu?', a: 'Noodloop is een ernstig signaal. Bel ons onmiddellijk op 0498 54 54 74. We bespreken de situatie en plannen een urgente afspraak in.' },
      { q: 'Werken jullie ook voor Antwerpse bedrijfsvloten?', a: 'Ja, we werken voor bedrijfsvloten. Neem contact op voor onze B2B-tarieven en planningsopties.' },
      { q: 'Wat zijn de meest voorkomende DPF-problemen bij Antwerpse stadsrijders?', a: 'Stop-and-go verkeer, korte stadsritten en files zijn de hoofdoorzaken. De motor bereikt niet de temperatuur die nodig is voor automatische regeneratie.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'sint-niklaas', 'mechelen', 'boom', 'willebroek', 'bornem', 'beveren-kruibeke-zwijndrecht'],
  },
  {
    city: 'Mechelen',
    slug: 'mechelen',
    province: 'Antwerpen',
    region: 'Mechelen',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Willebroek', 'Bonheiden', 'Putte', 'Heist-op-den-Berg', 'Duffel', 'Sint-Katelijne-Waver'],
    highway: 'E19 / A12',
    seoTitle: 'Roetfilter Reinigen in Mechelen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Mechelen. 50 minuten naar Lokeren. Professionele DPF reiniging, diagnose en revisie. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Mechelen',
    intro: 'Mechelen, de stad van de Maneblussers, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Mechelen, Willebroek, Bonheiden en de ruime Mechelse regio kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Mechelen is een belangrijke pendelstad langs de E19 en A12. Wie dagelijks pendelt naar Brussel of Antwerpen, rijdt weliswaar lange trajecten, maar de combinatie met korte ritten in de stad zorgt toch voor problemen. We zien bij klanten uit Mechelen regelmatig verstopte DPFs bij wagens die al een tijdje het lampje negeerden.',
    whyLokeren: 'Vanuit Mechelen rijdt u via de E19 of A12 richting Lokeren. In 50 minuten staat u bij ons. We voeren een volledige diagnose uit en reinigen de roetfilter professioneel.',
    trustParagraph: 'Klanten uit Mechelen en de Mechelse regio waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Mechelen? Bel 0498 54 54 74 of vraag een gratis offerte aan.',
    faqs: [
      { q: 'Hoe ver is Mechelen van Roetfilter Center?', a: 'Vanuit Mechelen rijdt u via de E19 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt in Mechelen — wat nu?', a: 'Bel ons op 0498 54 54 74. We plannen een afspraak in voor diagnose en reiniging.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250. De diagnose (€75) wordt terugbetaald bij herstelling.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
      { q: 'Werken jullie ook voor bestelwagens uit Mechelen?', a: 'Ja, we reinigen roetfilters van bestelwagens voor €250–€350.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'gent', 'sint-niklaas', 'willebroek', 'boom', 'bornem', 'dendermonde'],
  },
  {
    city: 'Boom',
    slug: 'boom',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 1,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Rumst', 'Niel', 'Schelle', 'Hemiksem', 'Aartselaar'],
    highway: 'A12 / E19',
    seoTitle: 'Roetfilter Reinigen in Boom | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Boom en de Rupelstreek. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Boom',
    intro: 'Boom, de stad aan de Rupel, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Boom, Rumst, Niel en de ruime Rupelstreek kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Boom is een industriële gemeente met veel pendelaars richting Antwerpen of Brussel. Wie dagelijks rijdt via de A12 of E19, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Boom rijdt u via de A12 of E19 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Boom en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Boom of de Rupelstreek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Boom van Roetfilter Center?', a: 'Vanuit Boom rijdt u via de A12 of E19 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'willebroek', 'bornem', 'sint-niklaas', 'gent', 'dendermonde'],
  },
  {
    city: 'Bornem',
    slug: 'bornem',
    province: 'Antwerpen',
    region: 'Scheldeland',
    priority: 1,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Puurs-Sint-Amands', 'Willebroek', 'Temse', 'Hamme', 'Sint-Amands'],
    highway: 'N16 / A12',
    seoTitle: 'Roetfilter Reinigen in Bornem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Bornem en het Scheldeland. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Bornem',
    intro: 'Bornem, gelegen aan de Schelde, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Bornem, Puurs-Sint-Amands en het ruime Scheldeland kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Bornem is een pendelgemeente langs de N16. Wie dagelijks rijdt naar Antwerpen of Mechelen, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Bornem rijdt u via de N16 of A12 rechtstreeks naar Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Bornem en het Scheldeland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Bornem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Bornem van Roetfilter Center?', a: 'Vanuit Bornem rijdt u via de N16 of A12 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'willebroek', 'temse', 'sint-niklaas', 'gent', 'dendermonde'],
  },
  {
    city: 'Willebroek',
    slug: 'willebroek',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 1,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Boom', 'Bornem', 'Puurs-Sint-Amands', 'Mechelen', 'Rumst'],
    highway: 'A12 / E19',
    seoTitle: 'Roetfilter Reinigen in Willebroek | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Willebroek. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Willebroek',
    intro: 'Willebroek, gelegen aan het kanaal Brussel-Schelde, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Willebroek en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Willebroek is een industriële gemeente met veel pendelaars en bedrijfsvoertuigen. Wie dagelijks rijdt via de A12 of E19, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Willebroek rijdt u via de A12 of E19 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Willebroek en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Willebroek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Willebroek van Roetfilter Center?', a: 'Vanuit Willebroek rijdt u via de A12 of E19 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'boom', 'bornem', 'sint-niklaas', 'gent', 'dendermonde'],
  },
  {
    city: 'Puurs-Sint-Amands',
    slug: 'puurs-sint-amands',
    province: 'Antwerpen',
    region: 'Scheldeland',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Bornem', 'Willebroek', 'Temse', 'Sint-Amands', 'Lippelo'],
    highway: 'N16 / A12',
    seoTitle: 'Roetfilter Reinigen in Puurs-Sint-Amands | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Puurs-Sint-Amands. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Puurs-Sint-Amands',
    intro: 'Puurs-Sint-Amands, gelegen aan de Schelde, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Puurs-Sint-Amands en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Puurs-Sint-Amands is een pendelgemeente langs de N16. Wie dagelijks rijdt naar Antwerpen of Mechelen, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Puurs-Sint-Amands rijdt u via de N16 of A12 rechtstreeks naar Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Puurs-Sint-Amands en het Scheldeland waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Puurs-Sint-Amands? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Puurs-Sint-Amands van Roetfilter Center?', a: 'Vanuit Puurs-Sint-Amands rijdt u via de N16 of A12 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'bornem', 'willebroek', 'temse', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Zwijndrecht',
    slug: 'zwijndrecht',
    province: 'Antwerpen',
    region: 'Antwerpen',
    priority: 2,
    driveTime: '30 minuten',
    driveMinutes: 30,
    nearbyTowns: ['Beveren-Kruibeke-Zwijndrecht', 'Kruibeke', 'Antwerpen', 'Schelle', 'Hemiksem'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Zwijndrecht | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Zwijndrecht. 30 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Zwijndrecht',
    intro: 'Zwijndrecht, gelegen aan de Schelde tegenover Antwerpen, ligt op 30 minuten van onze werkplaats in Lokeren. Klanten uit Zwijndrecht en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Zwijndrecht is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Zwijndrecht rijdt u via de E17 of A12 richting Lokeren. In 30 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Zwijndrecht en de Antwerpse regio waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Zwijndrecht? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Zwijndrecht van Roetfilter Center?', a: 'Vanuit Zwijndrecht rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 30 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'beveren-kruibeke-zwijndrecht', 'mechelen', 'boom', 'sint-niklaas', 'gent', 'dendermonde'],
  },
  {
    city: 'Mortsel',
    slug: 'mortsel',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Edegem', 'Kontich', 'Aartselaar', 'Hove', 'Lint'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Mortsel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Mortsel. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Mortsel',
    intro: 'Mortsel, gelegen in de Antwerpse rand, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Mortsel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Mortsel is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Mortsel rijdt u via de E17 of A12 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Mortsel en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Mortsel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Mortsel van Roetfilter Center?', a: 'Vanuit Mortsel rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'edegem', 'kontich', 'aartselaar', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Edegem',
    slug: 'edegem',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Mortsel', 'Kontich', 'Aartselaar', 'Hove', 'Antwerpen'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Edegem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Edegem. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Edegem',
    intro: 'Edegem, gelegen in de Antwerpse rand, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Edegem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Edegem is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Edegem rijdt u via de E17 of A12 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Edegem en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Edegem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Edegem van Roetfilter Center?', a: 'Vanuit Edegem rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'mortsel', 'kontich', 'aartselaar', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Kontich',
    slug: 'kontich',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Edegem', 'Aartselaar', 'Hove', 'Lint', 'Mortsel'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Kontich | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Kontich. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Kontich',
    intro: 'Kontich, gelegen in de Antwerpse rand, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Kontich en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Kontich is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Kontich rijdt u via de E17 of A12 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Kontich en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Kontich? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Kontich van Roetfilter Center?', a: 'Vanuit Kontich rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'edegem', 'aartselaar', 'hove', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Aartselaar',
    slug: 'aartselaar',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Kontich', 'Edegem', 'Hove', 'Boom', 'Niel'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Aartselaar | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Aartselaar. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Aartselaar',
    intro: 'Aartselaar, gelegen in de Antwerpse rand, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Aartselaar en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Aartselaar is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Aartselaar rijdt u via de E17 of A12 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Aartselaar en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Aartselaar? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Aartselaar van Roetfilter Center?', a: 'Vanuit Aartselaar rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'kontich', 'edegem', 'boom', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Hove',
    slug: 'hove',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Kontich', 'Edegem', 'Lint', 'Mortsel', 'Aartselaar'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Hove | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Hove. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Hove',
    intro: 'Hove, gelegen in de Antwerpse rand, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Hove en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Hove is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Hove rijdt u via de E17 of A12 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Hove en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Hove? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Hove van Roetfilter Center?', a: 'Vanuit Hove rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'kontich', 'edegem', 'lint', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Lint',
    slug: 'lint',
    province: 'Antwerpen',
    region: 'Antwerpse rand',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Hove', 'Kontich', 'Lier', 'Duffel', 'Mortsel'],
    highway: 'E17 / A12',
    seoTitle: 'Roetfilter Reinigen in Lint | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Lint. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Lint',
    intro: 'Lint, gelegen in de Antwerpse rand, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Lint en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lint is een gemeente met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E17 of A12, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lint rijdt u via de E17 of A12 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lint en de Antwerpse rand waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lint? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lint van Roetfilter Center?', a: 'Vanuit Lint rijdt u via de E17 of A12 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'hove', 'kontich', 'lier', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Rumst',
    slug: 'rumst',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Boom', 'Niel', 'Schelle', 'Hemiksem', 'Mechelen'],
    highway: 'A12 / E19',
    seoTitle: 'Roetfilter Reinigen in Rumst | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Rumst. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Rumst',
    intro: 'Rumst, gelegen in de Rupelstreek, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Rumst en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Rumst is een gemeente met veel pendelaars. Wie dagelijks rijdt via de A12 of E19, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Rumst rijdt u via de A12 of E19 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Rumst en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Rumst? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Rumst van Roetfilter Center?', a: 'Vanuit Rumst rijdt u via de A12 of E19 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'boom', 'niel', 'schelle', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Niel',
    slug: 'niel',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 2,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Boom', 'Schelle', 'Hemiksem', 'Rumst', 'Aartselaar'],
    highway: 'A12 / E19',
    seoTitle: 'Roetfilter Reinigen in Niel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Niel. 45 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Niel',
    intro: 'Niel, gelegen in de Rupelstreek, ligt op 45 minuten van onze werkplaats in Lokeren. Klanten uit Niel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Niel is een gemeente met veel pendelaars. Wie dagelijks rijdt via de A12 of E19, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Niel rijdt u via de A12 of E19 richting Lokeren. In 45 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Niel en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Niel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Niel van Roetfilter Center?', a: 'Vanuit Niel rijdt u via de A12 of E19 naar Lokeren. De rit duurt gemiddeld 45 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'boom', 'schelle', 'hemiksem', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Schelle',
    slug: 'schelle',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Niel', 'Boom', 'Hemiksem', 'Aartselaar', 'Zwijndrecht'],
    highway: 'A12 / E17',
    seoTitle: 'Roetfilter Reinigen in Schelle | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Schelle. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Schelle',
    intro: 'Schelle, gelegen in de Rupelstreek, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Schelle en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Schelle is een gemeente met veel pendelaars. Wie dagelijks rijdt via de A12 of E17, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Schelle rijdt u via de A12 of E17 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Schelle en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Schelle? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Schelle van Roetfilter Center?', a: 'Vanuit Schelle rijdt u via de A12 of E17 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'niel', 'boom', 'hemiksem', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Hemiksem',
    slug: 'hemiksem',
    province: 'Antwerpen',
    region: 'Rupelstreek',
    priority: 2,
    driveTime: '40 minuten',
    driveMinutes: 40,
    nearbyTowns: ['Schelle', 'Niel', 'Boom', 'Aartselaar', 'Zwijndrecht'],
    highway: 'A12 / E17',
    seoTitle: 'Roetfilter Reinigen in Hemiksem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Hemiksem. 40 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Hemiksem',
    intro: 'Hemiksem, gelegen in de Rupelstreek, ligt op 40 minuten van onze werkplaats in Lokeren. Klanten uit Hemiksem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Hemiksem is een gemeente met veel pendelaars. Wie dagelijks rijdt via de A12 of E17, kent de files. Stop-and-go verkeer is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Hemiksem rijdt u via de A12 of E17 richting Lokeren. In 40 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Hemiksem en de Rupelstreek waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Hemiksem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Hemiksem van Roetfilter Center?', a: 'Vanuit Hemiksem rijdt u via de A12 of E17 naar Lokeren. De rit duurt gemiddeld 40 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'schelle', 'niel', 'boom', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Lier',
    slug: 'lier',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Nijlen', 'Ranst', 'Berlaar', 'Duffel', 'Bonheiden'],
    highway: 'E313 / A12',
    seoTitle: 'Roetfilter Reinigen in Lier | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Lier. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Lier',
    intro: 'Lier, de stad van de Zimmertoren, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Lier en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Lier is een actieve stad met veel pendelaars richting Antwerpen. Wie dagelijks rijdt via de E313 of A12, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Lier rijdt u via de E313 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Lier en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Lier? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Lier van Roetfilter Center?', a: 'Vanuit Lier rijdt u via de E313 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'nijlen', 'ranst', 'duffel', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Duffel',
    slug: 'duffel',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Mechelen', 'Lier', 'Bonheiden', 'Putte', 'Nijlen'],
    highway: 'A12 / N1',
    seoTitle: 'Roetfilter Reinigen in Duffel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Duffel. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Duffel',
    intro: 'Duffel, gelegen tussen Mechelen en Lier, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Duffel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Duffel is een pendelgemeente. Wie dagelijks rijdt via de A12 of N1, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Duffel rijdt u via de A12 of N1 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Duffel en de Mechelse regio waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Duffel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Duffel van Roetfilter Center?', a: 'Vanuit Duffel rijdt u via de A12 of N1 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'lier', 'bonheiden', 'nijlen', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Nijlen',
    slug: 'nijlen',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Lier', 'Duffel', 'Ranst', 'Berlaar', 'Grobbendonk'],
    highway: 'E313 / A12',
    seoTitle: 'Roetfilter Reinigen in Nijlen | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Nijlen. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Nijlen',
    intro: 'Nijlen, gelegen in de Kempen, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Nijlen en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Nijlen is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E313 of A12, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Nijlen rijdt u via de E313 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Nijlen en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Nijlen? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Nijlen van Roetfilter Center?', a: 'Vanuit Nijlen rijdt u via de E313 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'lier', 'duffel', 'ranst', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Ranst',
    slug: 'ranst',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Zandhoven', 'Wommelgem', 'Wijnegem', 'Lier', 'Nijlen'],
    highway: 'E313 / A12',
    seoTitle: 'Roetfilter Reinigen in Ranst | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ranst. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ranst',
    intro: 'Ranst, gelegen in de Kempen, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Ranst en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ranst is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E313 of A12, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Ranst rijdt u via de E313 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ranst en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ranst? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ranst van Roetfilter Center?', a: 'Vanuit Ranst rijdt u via de E313 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'lier', 'nijlen', 'duffel', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Heist-op-den-Berg',
    slug: 'heist-op-den-berg',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Putte', 'Bonheiden', 'Hulshout', 'Westerlo', 'Duffel'],
    highway: 'N15 / A12',
    seoTitle: 'Roetfilter Reinigen in Heist-op-den-Berg | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Heist-op-den-Berg. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Heist-op-den-Berg',
    intro: 'Heist-op-den-Berg, gelegen in de Kempen, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Heist-op-den-Berg en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Heist-op-den-Berg is een gemeente met veel pendelaars. Wie dagelijks rijdt via de N15 of A12, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Heist-op-den-Berg rijdt u via de N15 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Heist-op-den-Berg en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Heist-op-den-Berg? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Heist-op-den-Berg van Roetfilter Center?', a: 'Vanuit Heist-op-den-Berg rijdt u via de N15 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'putte', 'bonheiden', 'duffel', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Herentals',
    slug: 'herentals',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '60 minuten',
    driveMinutes: 60,
    nearbyTowns: ['Olen', 'Grobbendonk', 'Vorselaar', 'Lille', 'Westerlo'],
    highway: 'E313 / N13',
    seoTitle: 'Roetfilter Reinigen in Herentals | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Herentals. 60 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Herentals',
    intro: 'Herentals, de hoofdstad van de Kempen, ligt op 60 minuten van onze werkplaats in Lokeren. Klanten uit Herentals en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Herentals is een actieve stad met veel pendelaars. Wie dagelijks rijdt via de E313 of N13, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Herentals rijdt u via de E313 of N13 richting Lokeren. In 60 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Herentals en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Herentals? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Herentals van Roetfilter Center?', a: 'Vanuit Herentals rijdt u via de E313 of N13 naar Lokeren. De rit duurt gemiddeld 60 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'olen', 'grobbendonk', 'westerlo', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Geel',
    slug: 'geel',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '65 minuten',
    driveMinutes: 65,
    nearbyTowns: ['Mol', 'Meerhout', 'Laakdal', 'Westerlo', 'Herentals'],
    highway: 'E313 / N19',
    seoTitle: 'Roetfilter Reinigen in Geel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Geel. 65 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Geel',
    intro: 'Geel, de stad van de psychiatrische zorg, ligt op 65 minuten van onze werkplaats in Lokeren. Klanten uit Geel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Geel is een actieve stad met veel pendelaars. Wie dagelijks rijdt via de E313 of N19, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Geel rijdt u via de E313 of N19 richting Lokeren. In 65 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Geel en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Geel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Geel van Roetfilter Center?', a: 'Vanuit Geel rijdt u via de E313 of N19 naar Lokeren. De rit duurt gemiddeld 65 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'mol', 'herentals', 'westerlo', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Mol',
    slug: 'mol',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '70 minuten',
    driveMinutes: 70,
    nearbyTowns: ['Balen', 'Dessel', 'Retie', 'Geel', 'Meerhout'],
    highway: 'E313 / N71',
    seoTitle: 'Roetfilter Reinigen in Mol | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Mol. 70 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Mol',
    intro: 'Mol, gelegen in de Kempen, ligt op 70 minuten van onze werkplaats in Lokeren. Klanten uit Mol en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Mol is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E313 of N71, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Mol rijdt u via de E313 of N71 richting Lokeren. In 70 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Mol en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Mol? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Mol van Roetfilter Center?', a: 'Vanuit Mol rijdt u via de E313 of N71 naar Lokeren. De rit duurt gemiddeld 70 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'geel', 'balen', 'dessel', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Turnhout',
    slug: 'turnhout',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '70 minuten',
    driveMinutes: 70,
    nearbyTowns: ['Beerse', 'Oud-Turnhout', 'Vosselaar', 'Merksplas', 'Ravels'],
    highway: 'E34 / A21',
    seoTitle: 'Roetfilter Reinigen in Turnhout | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Turnhout. 70 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Turnhout',
    intro: 'Turnhout, de hoofdstad van de Kempen, ligt op 70 minuten van onze werkplaats in Lokeren. Klanten uit Turnhout en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Turnhout is een actieve stad met veel pendelaars. Wie dagelijks rijdt via de E34 of A21, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Turnhout rijdt u via de E34 of A21 richting Lokeren. In 70 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Turnhout en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Turnhout? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Turnhout van Roetfilter Center?', a: 'Vanuit Turnhout rijdt u via de E34 of A21 naar Lokeren. De rit duurt gemiddeld 70 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'beerse', 'oud-turnhout', 'vosselaar', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Beerse',
    slug: 'beerse',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '70 minuten',
    driveMinutes: 70,
    nearbyTowns: ['Turnhout', 'Oud-Turnhout', 'Vosselaar', 'Lille', 'Merksplas'],
    highway: 'E34 / N12',
    seoTitle: 'Roetfilter Reinigen in Beerse | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Beerse. 70 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Beerse',
    intro: 'Beerse, gelegen in de Kempen, ligt op 70 minuten van onze werkplaats in Lokeren. Klanten uit Beerse en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Beerse is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E34 of N12, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Beerse rijdt u via de E34 of N12 richting Lokeren. In 70 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Beerse en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Beerse? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Beerse van Roetfilter Center?', a: 'Vanuit Beerse rijdt u via de E34 of N12 naar Lokeren. De rit duurt gemiddeld 70 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'turnhout', 'oud-turnhout', 'vosselaar', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Westerlo',
    slug: 'westerlo',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '65 minuten',
    driveMinutes: 65,
    nearbyTowns: ['Herentals', 'Geel', 'Laakdal', 'Hulshout', 'Olen'],
    highway: 'E313 / N19',
    seoTitle: 'Roetfilter Reinigen in Westerlo | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Westerlo. 65 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Westerlo',
    intro: 'Westerlo, gelegen in de Kempen, ligt op 65 minuten van onze werkplaats in Lokeren. Klanten uit Westerlo en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Westerlo is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E313 of N19, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Westerlo rijdt u via de E313 of N19 richting Lokeren. In 65 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Westerlo en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Westerlo? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Westerlo van Roetfilter Center?', a: 'Vanuit Westerlo rijdt u via de E313 of N19 naar Lokeren. De rit duurt gemiddeld 65 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'herentals', 'geel', 'laakdal', 'gent', 'sint-niklaas'],
  },
  {
    city: 'Grobbendonk',
    slug: 'grobbendonk',
    province: 'Antwerpen',
    region: 'Kempen',
    priority: 2,
    driveTime: '60 minuten',
    driveMinutes: 60,
    nearbyTowns: ['Herentals', 'Olen', 'Vorselaar', 'Nijlen', 'Westerlo'],
    highway: 'E313 / N13',
    seoTitle: 'Roetfilter Reinigen in Grobbendonk | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Grobbendonk. 60 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Grobbendonk',
    intro: 'Grobbendonk, gelegen in de Kempen, ligt op 60 minuten van onze werkplaats in Lokeren. Klanten uit Grobbendonk en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Grobbendonk is een gemeente met veel pendelaars. Wie dagelijks rijdt via de E313 of N13, kent de files. Korte ritten en pendelen combineren is funest voor de roetfilter.',
    whyLokeren: 'Vanuit Grobbendonk rijdt u via de E313 of N13 richting Lokeren. In 60 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Grobbendonk en de Kempen waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Grobbendonk? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Grobbendonk van Roetfilter Center?', a: 'Vanuit Grobbendonk rijdt u via de E313 of N13 naar Lokeren. De rit duurt gemiddeld 60 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'antwerpen', 'mechelen', 'herentals', 'olen', 'westerlo', 'gent', 'sint-niklaas'],
  },
];

export { antwerpenCities };

// ─── BRUSSELS CITIES ───────────────────────────────────────────────────────
const brusselsCities: LocatieData[] = [
  {
    city: 'Brussel',
    slug: 'brussel',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '45 minuten',
    driveMinutes: 45,
    nearbyTowns: ['Etterbeek', 'Schaarbeek', 'Anderlecht', 'Molenbeek-Saint-Jean', 'Elsene'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Brussel | Roetfilter Center',
    seoDescription: 'Roetfilter laten reinigen in Brussel of omgeving? Roetfilter Center helpt met DPF diagnose, roetfilter reiniging, AdBlue storingen en uitstootproblemen vanuit onze werkplaats in Lokeren. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Brussel',
    intro: 'Brussel, de hoofdstad van België en Europa, heeft een van de strengste emissiezones van het land. Klanten uit Brussel, Etterbeek, Schaarbeek en het ruime Brussels Gewest rijden dagelijks naar onze werkplaats in Lokeren — slechts 45 minuten via de E40. Roetfilter Center is de erkende DPF-specialist voor het volledige Brussels Gewest.',
    problemParagraph: 'Brusselse automobilisten rijden dagelijks in een van de drukste steden van Europa. Korte stadsritten, files op de Ring en de druk van de lage-emissiezone zorgen ervoor dat roetfilters sneller verstoppen dan gemiddeld. Bovendien zien we bij klanten uit Brussel regelmatig AdBlue-storingen bij nieuwere dieselwagens met SCR-systeem — een probleem dat we in één bezoek kunnen oplossen.',
    whyLokeren: 'Vanuit Brussel rijdt u via de E40 richting Gent en neemt u de afrit Lokeren. In 45 minuten staat u bij ons. We voeren een volledige diagnose uit, reinigen de roetfilter professioneel en testen het resultaat met een officiële emissietest. Na reiniging voldoet uw wagen opnieuw aan de emissienormen.',
    trustParagraph: 'Klanten uit Brussel kiezen voor Roetfilter Center omdat we snelle service, transparante communicatie en bewezen resultaten combineren. We werken met alle merken — van Volkswagen en BMW tot Mercedes en Audi. Onze technici kennen de DPF-problematiek van Brusselse stadsrijders door en door.',
    cta: 'Klant uit Brussel? Bel 0498 54 54 74 of vraag een gratis offerte aan. Wij helpen u dezelfde dag.',
    faqs: [
      { q: 'Hoe ver is Brussel van Roetfilter Center in Lokeren?', a: 'Vanuit Brussel rijdt u via de E40 richting Gent en neemt u de afrit Lokeren. De rit duurt gemiddeld 45 minuten buiten de spits.' },
      { q: 'Mijn AdBlue-lampje brandt in Brussel — wat nu?', a: 'Een AdBlue-storing kan verschillende oorzaken hebben. Bel ons op 0498 54 54 74 voor een diagnose. We lossen AdBlue-storingen op naast roetfilter problemen.' },
      { q: 'Helpt roetfilter reiniging bij emissie-problemen in Brussel?', a: 'Ja, een gereinigde roetfilter zorgt voor lagere uitstoot. Na reiniging voeren wij een officiële emissietest uit.' },
      { q: 'Mijn wagen gaat in noodloop in Brussel — wat moet ik doen?', a: 'Noodloop is een ernstig signaal. Bel ons onmiddellijk op 0498 54 54 74. We bespreken de situatie en plannen een urgente afspraak in.' },
      { q: 'Werken jullie ook voor Brusselse bedrijfsvloten?', a: 'Ja, we werken voor bedrijfsvloten. Neem contact op voor onze B2B-tarieven en planningsopties.' },
    ],
    nearbyCityLinks: ['lokeren', 'gent', 'antwerpen', 'mechelen', 'anderlecht', 'schaarbeek', 'molenbeek-saint-jean', 'sint-niklaas'],
  },
  {
    city: 'Anderlecht',
    slug: 'anderlecht',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Molenbeek-Saint-Jean', 'Brussel', 'Sint-Gillis', 'Vorst', 'Dilbeek'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Anderlecht | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Anderlecht. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Anderlecht',
    intro: 'Anderlecht, een van de grootste gemeenten van het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Anderlecht en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Anderlecht is een dichtbevolkte gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen. We zien bij klanten uit Anderlecht regelmatig verstopte DPFs en AdBlue-storingen.',
    whyLokeren: 'Vanuit Anderlecht rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Anderlecht en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Anderlecht? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Anderlecht van Roetfilter Center?', a: 'Vanuit Anderlecht rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'molenbeek-saint-jean', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Schaarbeek',
    slug: 'schaarbeek',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Evere', 'Sint-Joost-ten-Node', 'Brussel', 'Etterbeek', 'Elsene'],
    highway: 'E19 / A12',
    seoTitle: 'Roetfilter Reinigen in Schaarbeek | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Schaarbeek. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Schaarbeek',
    intro: 'Schaarbeek, een van de grootste gemeenten van het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Schaarbeek en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Schaarbeek is een dichtbevolkte gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Schaarbeek rijdt u via de E19 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Schaarbeek en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Schaarbeek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Schaarbeek van Roetfilter Center?', a: 'Vanuit Schaarbeek rijdt u via de E19 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'evere', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Molenbeek-Saint-Jean',
    slug: 'molenbeek-saint-jean',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Anderlecht', 'Brussel', 'Koekelberg', 'Ganshoren', 'Jette'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Molenbeek-Saint-Jean | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Molenbeek-Saint-Jean. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Molenbeek-Saint-Jean',
    intro: 'Molenbeek-Saint-Jean, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Molenbeek en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Molenbeek is een dichtbevolkte gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Molenbeek rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Molenbeek en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Molenbeek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Molenbeek van Roetfilter Center?', a: 'Vanuit Molenbeek rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'anderlecht', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Jette',
    slug: 'jette',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Ganshoren', 'Koekelberg', 'Molenbeek-Saint-Jean', 'Brussel', 'Laeken'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Jette | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Jette. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Jette',
    intro: 'Jette, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Jette en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Jette is een gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Jette rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Jette en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Jette? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Jette van Roetfilter Center?', a: 'Vanuit Jette rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'ganshoren', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Evere',
    slug: 'evere',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Schaarbeek', 'Sint-Joost-ten-Node', 'Brussel', 'Woluwe-Saint-Lambert', 'Laeken'],
    highway: 'E19 / A12',
    seoTitle: 'Roetfilter Reinigen in Evere | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Evere. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Evere',
    intro: 'Evere, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Evere en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Evere is een gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Evere rijdt u via de E19 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Evere en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Evere? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Evere van Roetfilter Center?', a: 'Vanuit Evere rijdt u via de E19 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'schaarbeek', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Ukkel',
    slug: 'ukkel',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 1,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Sint-Gillis', 'Vorst', 'Elsene', 'Watermael-Boitsfort', 'Rhode-Saint-Genèse'],
    highway: 'A12 / E19',
    seoTitle: 'Roetfilter Reinigen in Ukkel | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ukkel. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ukkel',
    intro: 'Ukkel, een van de welgesteldste gemeenten van het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Ukkel en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ukkel is een gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Ukkel rijdt u via de A12 of E19 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ukkel en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ukkel? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ukkel van Roetfilter Center?', a: 'Vanuit Ukkel rijdt u via de A12 of E19 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'anderlecht', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Ixelles',
    slug: 'ixelles',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Brussel', 'Etterbeek', 'Ukkel', 'Sint-Gillis', 'Vorst'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Ixelles | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ixelles. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ixelles',
    intro: 'Ixelles, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Ixelles en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ixelles is een gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Ixelles rijdt u via de E40 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ixelles en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ixelles? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ixelles van Roetfilter Center?', a: 'Vanuit Ixelles rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'etterbeek', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Etterbeek',
    slug: 'etterbeek',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Ixelles', 'Brussel', 'Watermael-Boitsfort', 'Ukkel', 'Auderghem'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Etterbeek | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Etterbeek. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Etterbeek',
    intro: 'Etterbeek, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Etterbeek en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Etterbeek is een gemeente met veel stadsverkeer. Korte ritten, files en de druk van de emissienormen zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Etterbeek rijdt u via de E40 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Etterbeek en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Etterbeek? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Etterbeek van Roetfilter Center?', a: 'Vanuit Etterbeek rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'ixelles', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Ganshoren',
    slug: 'ganshoren',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Jette', 'Koekelberg', 'Molenbeek-Saint-Jean', 'Brussel', 'Laeken'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Ganshoren | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Ganshoren. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Ganshoren',
    intro: 'Ganshoren, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Ganshoren en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Ganshoren is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Ganshoren rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Ganshoren en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Ganshoren? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Ganshoren van Roetfilter Center?', a: 'Vanuit Ganshoren rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'jette', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Koekelberg',
    slug: 'koekelberg',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Ganshoren', 'Jette', 'Molenbeek-Saint-Jean', 'Brussel', 'Laeken'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Koekelberg | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Koekelberg. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Koekelberg',
    intro: 'Koekelberg, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Koekelberg en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Koekelberg is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Koekelberg rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Koekelberg en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Koekelberg? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Koekelberg van Roetfilter Center?', a: 'Vanuit Koekelberg rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'ganshoren', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Auderghem',
    slug: 'auderghem',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Watermael-Boitsfort', 'Etterbeek', 'Ukkel', 'Woluwe-Saint-Pierre', 'Brussel'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Auderghem | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Auderghem. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Auderghem',
    intro: 'Auderghem, gelegen in het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Auderghem en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Auderghem is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Auderghem rijdt u via de E40 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Auderghem en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Auderghem? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Auderghem van Roetfilter Center?', a: 'Vanuit Auderghem rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'etterbeek', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Berchem-Sainte-Agathe',
    slug: 'berchem-sainte-agathe',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Ganshoren', 'Jette', 'Molenbeek-Saint-Jean', 'Brussel', 'Laeken'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Berchem-Sainte-Agathe | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Berchem-Sainte-Agathe. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Berchem-Sainte-Agathe',
    intro: 'Berchem-Sainte-Agathe, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Berchem-Sainte-Agathe en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Berchem-Sainte-Agathe is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Berchem-Sainte-Agathe rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Berchem-Sainte-Agathe en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Berchem-Sainte-Agathe? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Berchem-Sainte-Agathe van Roetfilter Center?', a: 'Vanuit Berchem-Sainte-Agathe rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'ganshoren', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Saint-Gilles',
    slug: 'saint-gilles',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Anderlecht', 'Ukkel', 'Ixelles', 'Brussel', 'Vorst'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Saint-Gilles | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Saint-Gilles. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Saint-Gilles',
    intro: 'Saint-Gilles, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Saint-Gilles en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Saint-Gilles is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Saint-Gilles rijdt u via de A10 of E40 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Saint-Gilles en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Saint-Gilles? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Saint-Gilles van Roetfilter Center?', a: 'Vanuit Saint-Gilles rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'anderlecht', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Saint-Josse-ten-Noode',
    slug: 'saint-josse-ten-noode',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '50 minuten',
    driveMinutes: 50,
    nearbyTowns: ['Schaarbeek', 'Evere', 'Brussel', 'Etterbeek', 'Laeken'],
    highway: 'E19 / A12',
    seoTitle: 'Roetfilter Reinigen in Saint-Josse-ten-Noode | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Saint-Josse-ten-Noode. 50 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Saint-Josse-ten-Noode',
    intro: 'Saint-Josse-ten-Noode, gelegen in het Brussels Gewest, ligt op 50 minuten van onze werkplaats in Lokeren. Klanten uit Saint-Josse-ten-Noode en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Saint-Josse-ten-Noode is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Saint-Josse-ten-Noode rijdt u via de E19 of A12 richting Lokeren. In 50 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Saint-Josse-ten-Noode en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Saint-Josse-ten-Noode? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Saint-Josse-ten-Noode van Roetfilter Center?', a: 'Vanuit Saint-Josse-ten-Noode rijdt u via de E19 of A12 naar Lokeren. De rit duurt gemiddeld 50 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'schaarbeek', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Woluwe-Saint-Lambert',
    slug: 'woluwe-saint-lambert',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Woluwe-Saint-Pierre', 'Evere', 'Etterbeek', 'Brussel', 'Schaarbeek'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Woluwe-Saint-Lambert | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Woluwe-Saint-Lambert. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Woluwe-Saint-Lambert',
    intro: 'Woluwe-Saint-Lambert, gelegen in het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Woluwe-Saint-Lambert en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Woluwe-Saint-Lambert is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Woluwe-Saint-Lambert rijdt u via de E40 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Woluwe-Saint-Lambert en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Woluwe-Saint-Lambert? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Woluwe-Saint-Lambert van Roetfilter Center?', a: 'Vanuit Woluwe-Saint-Lambert rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'evere', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Woluwe-Saint-Pierre',
    slug: 'woluwe-saint-pierre',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Woluwe-Saint-Lambert', 'Auderghem', 'Etterbeek', 'Brussel', 'Watermael-Boitsfort'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Woluwe-Saint-Pierre | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Woluwe-Saint-Pierre. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Woluwe-Saint-Pierre',
    intro: 'Woluwe-Saint-Pierre, gelegen in het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Woluwe-Saint-Pierre en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Woluwe-Saint-Pierre is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Woluwe-Saint-Pierre rijdt u via de E40 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Woluwe-Saint-Pierre en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Woluwe-Saint-Pierre? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Woluwe-Saint-Pierre van Roetfilter Center?', a: 'Vanuit Woluwe-Saint-Pierre rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'woluwe-saint-lambert', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Forest',
    slug: 'forest',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Anderlecht', 'Ukkel', 'Saint-Gilles', 'Vorst', 'Brussel'],
    highway: 'A10 / E40',
    seoTitle: 'Roetfilter Reinigen in Forest | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Forest. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Forest',
    intro: 'Forest, gelegen in het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Forest en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Forest is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Forest rijdt u via de A10 of E40 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Forest en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Forest? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Forest van Roetfilter Center?', a: 'Vanuit Forest rijdt u via de A10 of E40 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'anderlecht', 'sint-niklaas', 'dendermonde'],
  },
  {
    city: 'Watermael-Boitsfort',
    slug: 'watermael-boitsfort',
    province: 'Brussels',
    region: 'Brussels Hoofdstedelijk Gewest',
    priority: 2,
    driveTime: '55 minuten',
    driveMinutes: 55,
    nearbyTowns: ['Auderghem', 'Ukkel', 'Etterbeek', 'Woluwe-Saint-Pierre', 'Brussel'],
    highway: 'E40 / A12',
    seoTitle: 'Roetfilter Reinigen in Watermael-Boitsfort | Roetfilter Center',
    seoDescription: 'Roetfilter reinigen voor klanten uit Watermael-Boitsfort. 55 minuten naar Lokeren. Professionele DPF reiniging en diagnose. Bel 0498 54 54 74.',
    h1: 'Roetfilter Reinigen in Watermael-Boitsfort',
    intro: 'Watermael-Boitsfort, gelegen in het Brussels Gewest, ligt op 55 minuten van onze werkplaats in Lokeren. Klanten uit Watermael-Boitsfort en omgeving kiezen voor Roetfilter Center als hun vaste DPF-specialist.',
    problemParagraph: 'Watermael-Boitsfort is een gemeente met veel stadsverkeer. Korte ritten en files zorgen ervoor dat roetfilters sneller verstoppen.',
    whyLokeren: 'Vanuit Watermael-Boitsfort rijdt u via de E40 of A12 richting Lokeren. In 55 minuten staat u bij ons.',
    trustParagraph: 'Klanten uit Watermael-Boitsfort en het Brussels Gewest waarderen onze snelle service en eerlijke prijzen.',
    cta: 'Klant uit Watermael-Boitsfort? Bel 0498 54 54 74.',
    faqs: [
      { q: 'Hoe ver is Watermael-Boitsfort van Roetfilter Center?', a: 'Vanuit Watermael-Boitsfort rijdt u via de E40 of A12 naar Lokeren. De rit duurt gemiddeld 55 minuten.' },
      { q: 'Mijn roetfilterlampje brandt — wat nu?', a: 'Bel ons op 0498 54 54 74 voor een afspraak.' },
      { q: 'Wat kost roetfilter reinigen?', a: 'Reiniging voor personenwagens kost €195–€250.' },
      { q: 'Kan ik mijn wagen dezelfde dag ophalen?', a: 'Ja, in de meeste gevallen is uw wagen dezelfde dag klaar.' },
    ],
    nearbyCityLinks: ['lokeren', 'brussel', 'gent', 'antwerpen', 'mechelen', 'auderghem', 'sint-niklaas', 'dendermonde'],
  },
];

export { brusselsCities };

// ─── COMBINED EXPORT ───────────────────────────────────────────────────────
export const allLocaties: LocatieData[] = [
  ...locatiesData,
  ...oostVlaanderenExtra,
  ...antwerpenCities,
  ...brusselsCities,
];

export function getLocatie(slug: string): LocatieData | undefined {
  return allLocaties.find((l) => l.slug === slug);
}

export const locatiesByProvince: Record<string, LocatieData[]> = {
  'Oost-Vlaanderen': allLocaties.filter((l) => l.province === 'Oost-Vlaanderen'),
  'Antwerpen': allLocaties.filter((l) => l.province === 'Antwerpen'),
  'Brussels': allLocaties.filter((l) => l.province === 'Brussels'),
};
